// // // // import React, { useState } from 'react';
// // // // import { Clock, CheckCircle, XCircle, AlertTriangle, Eye } from 'lucide-react';
// // // // import './LeavesManagment.css';

// // // // // Mock data, typically from an API
// // // // const mockLeaveRequests = [
// // // //     { id: '1', employeeId: 'EMP001', employeeName: 'John Doe', type: 'PL', startDate: '2024-03-10', endDate: '2024-03-12', days: 3, appliedOn: '2024-02-20', status: 'approved', reportingManager: 'Alice Johnson', reason: 'Family vacation.', escalationDue: null },
// // // //     { id: '2', employeeId: 'EMP002', employeeName: 'Sarah Wilson', type: 'SL', startDate: '2024-03-01', endDate: '2024-03-01', days: 1, appliedOn: '2024-03-01', status: 'pending', reportingManager: 'Bob Smith', reason: 'Feeling unwell.', escalationDue: '2024-03-04' },
// // // //     { id: '3', employeeId: 'EMP003', employeeName: 'Mike Johnson', type: 'CL', startDate: '2024-03-05', endDate: '2024-03-05', days: 1, appliedOn: '2024-02-28', status: 'approved', reportingManager: 'Alice Johnson', reason: 'Personal appointment.', escalationDue: null },
// // // //     { id: '4', employeeId: 'EMP004', employeeName: 'Emily Davis', type: 'COMP', startDate: '2024-03-15', endDate: '2024-03-15', days: 1, appliedOn: '2024-02-25', status: 'rejected', reportingManager: 'Carol Davis', reason: 'Project deadline.', escalationDue: null },
// // // //     { id: '5', employeeId: 'EMP005', employeeName: 'David Brown', type: 'PL', startDate: '2024-04-01', endDate: '2024-04-05', days: 5, appliedOn: '2024-03-02', status: 'pending', reportingManager: 'Bob Smith', reason: 'Trip to hometown.', escalationDue: '2024-03-05' },
// // // // ];

// // // // const LeavesManagment = () => {
// // // //     const [leaveRequests] = useState(mockLeaveRequests);
// // // //     const [selectedLeave, setSelectedLeave] = useState(null);
// // // //     const [statusFilter, setStatusFilter] = useState('');
// // // //     const [typeFilter, setTypeFilter] = useState('');

// // // //     const filteredLeaves = leaveRequests.filter(leave => {
// // // //         const matchesStatus = !statusFilter || leave.status === statusFilter;
// // // //         const matchesType = !typeFilter || leave.type === typeFilter;
// // // //         return matchesStatus && matchesType;
// // // //     });

// // // //     const getStatusIcon = (status) => {
// // // //         switch (status) {
// // // //             case 'approved': return <CheckCircle className="icon-sm status-icon-approved" />;
// // // //             case 'rejected': return <XCircle className="icon-sm status-icon-rejected" />;
// // // //             default: return <Clock className="icon-sm status-icon-pending" />;
// // // //         }
// // // //     };

// // // //     const isEscalationDue = (leave) => {
// // // //         return leave.status === 'pending' && leave.escalationDue && new Date(leave.escalationDue) < new Date();
// // // //     };

// // // //     // Calculate stats based on the full list, not the filtered one
// // // //     const pendingCount = leaveRequests.filter(l => l.status === 'pending').length;
// // // //     const approvedCount = leaveRequests.filter(l => l.status === 'approved').length;
// // // //     const rejectedCount = leaveRequests.filter(l => l.status === 'rejected').length;
// // // //     const escalationCount = leaveRequests.filter(isEscalationDue).length;

// // // //     return (
// // // //         <div className="container">
// // // //             <div className="header">
// // // //                 <div>
// // // //                     <h1 className="header-title">Leave Management</h1>
// // // //                     <p className="header-subtitle">Review and approve employee leave requests</p>
// // // //                 </div>
// // // //             </div>

// // // //             <div className="stats-grid">
// // // //                 <div className="card stat-card">
// // // //                     <div className="card-content">
// // // //                         <div className="icon-wrapper"><Clock className="icon-lg text-yellow" /></div>
// // // //                         <div className="stat-details"><dl><dt>Pending Requests</dt><dd>{pendingCount}</dd></dl></div>
// // // //                     </div>
// // // //                 </div>
// // // //                  <div className="card stat-card">
// // // //                     <div className="card-content">
// // // //                         <div className="icon-wrapper"><CheckCircle className="icon-lg text-emerald" /></div>
// // // //                         <div className="stat-details"><dl><dt>Approved This Month</dt><dd>{approvedCount}</dd></dl></div>
// // // //                     </div>
// // // //                 </div>
// // // //                 <div className="card stat-card">
// // // //                     <div className="card-content">
// // // //                         <div className="icon-wrapper"><AlertTriangle className="icon-lg text-red" /></div>
// // // //                         <div className="stat-details"><dl><dt>Escalations</dt><dd>{escalationCount}</dd></dl></div>
// // // //                     </div>
// // // //                 </div>
// // // //                 <div className="card stat-card">
// // // //                     <div className="card-content">
// // // //                         <div className="icon-wrapper"><XCircle className="icon-lg text-red" /></div>
// // // //                         <div className="stat-details"><dl><dt>Rejected</dt><dd>{rejectedCount}</dd></dl></div>
// // // //                     </div>
// // // //                 </div>
// // // //             </div>

// // // //             <div className="card filter-card">
// // // //                 <div className="filter-controls">
// // // //                     <div className="filter-group">
// // // //                         <select className="form-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
// // // //                             <option value="">All Status</option>
// // // //                             <option value="pending">Pending</option>
// // // //                             <option value="approved">Approved</option>
// // // //                             <option value="rejected">Rejected</option>
// // // //                         </select>
// // // //                         <select className="form-select" value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
// // // //                             <option value="">All Leave Types</option>
// // // //                             <option value="PL">Personal Leave</option>
// // // //                             <option value="SL">Sick Leave</option>
// // // //                             <option value="CL">Casual Leave</option>
// // // //                             <option value="COMP">Comp Off</option>
// // // //                         </select>
// // // //                     </div>
// // // //                 </div>
// // // //             </div>

// // // //             <div className="card table-container">
// // // //                 <div className="table-wrapper">
// // // //                     <table className="leave-table">
// // // //                         <thead className="table-head">
// // // //                             <tr><th>Employee</th><th>Leave Type</th><th>Duration</th><th>Applied On</th><th>Status</th><th>Manager</th><th className="text-right">Actions</th></tr>
// // // //                         </thead>
// // // //                         <tbody className="table-body">
// // // //                             {filteredLeaves.map((leave) => (
// // // //                                 <tr key={leave.id} className={`table-row ${isEscalationDue(leave) ? 'escalated-row' : ''}`}>
// // // //                                     <td>
// // // //                                         <div className="employee-info">
// // // //                                             <div className="avatar"><span>{leave.employeeName.split(' ').map(n => n[0]).join('')}</span></div>
// // // //                                             <div className="employee-details">
// // // //                                                 <div className="employee-name">{leave.employeeName}</div>
// // // //                                                 <div className="employee-id">ID: {leave.employeeId}</div>
// // // //                                             </div>
// // // //                                         </div>
// // // //                                     </td>
// // // //                                     <td><span className={`type-badge type-${leave.type}`}>{leave.type}</span></td>
// // // //                                     <td>
// // // //                                         <div>{new Date(leave.startDate).toLocaleDateString()} - {new Date(leave.endDate).toLocaleDateString()}</div>
// // // //                                         <div className="day-count">{leave.days} day(s)</div>
// // // //                                     </td>
// // // //                                     <td>{new Date(leave.appliedOn).toLocaleDateString()}</td>
// // // //                                     <td>
// // // //                                         <div className="status-cell">
// // // //                                             {getStatusIcon(leave.status)}
// // // //                                             <span className={`status-badge status-${leave.status}`}>{leave.status}</span>
// // // //                                         </div>
// // // //                                     </td>
// // // //                                     <td>{leave.reportingManager}</td>
// // // //                                     <td>
// // // //                                         <div className="action-buttons">
// // // //                                             <button onClick={() => setSelectedLeave(leave)} className="action-btn-blue"><Eye className="icon-sm" /></button>
// // // //                                             {leave.status === 'pending' && (
// // // //                                                 <>
// // // //                                                     <button className="action-btn-emerald"><CheckCircle className="icon-sm" /></button>
// // // //                                                     <button className="action-btn-red"><XCircle className="icon-sm" /></button>
// // // //                                                 </>
// // // //                                             )}
// // // //                                             {isEscalationDue(leave) && <AlertTriangle className="icon-sm text-red" title="Escalation Due" />}
// // // //                                         </div>
// // // //                                     </td>
// // // //                                 </tr>
// // // //                             ))}
// // // //                         </tbody>
// // // //                     </table>
// // // //                 </div>
// // // //             </div>

// // // //             {selectedLeave && (
// // // //                 <div className="modal-overlay">
// // // //                     <div className="modal-container">
// // // //                         <div className="modal-header">
// // // //                             <h3 className="modal-title">Leave Request Details</h3>
// // // //                             <button onClick={() => setSelectedLeave(null)} className="modal-close-button">
// // // //                                 <span className="sr-only">Close</span>×
// // // //                             </button>
// // // //                         </div>
// // // //                         <div className="modal-body">
// // // //                             <div className="details-grid">
// // // //                                 <div><label>Employee</label><p>{selectedLeave.employeeName}</p></div>
// // // //                                 <div><label>Leave Type</label><p>{selectedLeave.type}</p></div>
// // // //                                 <div><label>Start Date</label><p>{new Date(selectedLeave.startDate).toLocaleDateString()}</p></div>
// // // //                                 <div><label>End Date</label><p>{new Date(selectedLeave.endDate).toLocaleDateString()}</p></div>
// // // //                                 <div><label>Total Days</label><p>{selectedLeave.days}</p></div>
// // // //                                 <div><label>Status</label><div className="status-cell">{getStatusIcon(selectedLeave.status)}<span className="status-text">{selectedLeave.status}</span></div></div>
// // // //                             </div>
// // // //                             <div><label>Reason</label><p>{selectedLeave.reason}</p></div>
// // // //                             <div><label>Reporting Manager</label><p>{selectedLeave.reportingManager}</p></div>
// // // //                             {selectedLeave.status === 'pending' && (
// // // //                                 <div className="modal-actions">
// // // //                                     <button className="btn btn-success"><CheckCircle className="icon-xs" />Approve</button>
// // // //                                     <button className="btn btn-danger"><XCircle className="icon-xs" />Reject</button>
// // // //                                 </div>
// // // //                             )}
// // // //                         </div>
// // // //                     </div>
// // // //                 </div>
// // // //             )}
// // // //         </div>
// // // //     );
// // // // };

// // // //             {selectedLeave && (
// // // //                 <div className="modal-overlay">
// // // //                     <div className="modal-container">
// // // //                         <div className="modal-header">
// // // //                             <h3 className="modal-title">Leave Request Details</h3>
// // // //                             <button onClick={() => setSelectedLeave(null)} className="modal-close-button">
// // // //                                 <span className="sr-only">Close</span>×</button>
// // // //                         </div>
// // // //                         <div className="modal-body">
// // // //                             <div className="details-grid">
// // // //                                 <div><label>Employee</label><p>{selectedLeave.employeeName}</p></div>
// // // //                                 <div><label>Leave Type</label><p>{selectedLeave.type}</p></div>
// // // //                                 <div><label>Start Date</label><p>{new Date(selectedLeave.startDate).toLocaleDateString()}</p></div>
// // // //                                 <div><label>End Date</label><p>{new Date(selectedLeave.endDate).toLocaleDateString()}</p></div>
// // // //                                 <div><label>Total Days</label><p>{selectedLeave.days}</p></div>
// // // //                                 <div><label>Status</label><div className="status-cell">{getStatusIcon(selectedLeave.status)}<span className="status-text">{selectedLeave.status}</span></div></div>
// // // //                             </div>
// // // //                             <div><label>Reason</label><p>{selectedLeave.reason}</p></div>
// // // //                             <div><label>Reporting Manager</label><p>{selectedLeave.reportingManager}</p></div>
// // // //                             {selectedLeave.status === 'pending' && (
// // // //                                 <div className="modal-actions">
// // // //                                     <button className="btn btn-success"><CheckCircle className="icon-xs" />Approve</button>
// // // //                                     <button className="btn btn-danger"><XCircle className="icon-xs" />Reject</button>
// // // //                                 </div>
// // // //                             )}
// // // //                         </div>
// // // //                     </div>
// // // //                 </div>
// // // //             )}
// // // //         </div>
// // // //     );
// // // // };

// // // import React, { useState, useEffect } from 'react';
// // // import axios from 'axios';
// // // import { 
// // //     Loader, Plus, Calendar as CalendarIcon, Settings, User, Users, FileText, Filter, RefreshCw, 
// // //     Edit2, Save, XCircle, CheckCircle, ChevronRight 
// // // } from 'lucide-react';
// // // import './LeavesManagment.css'; 

// import axios from 'axios';
// import { 
//     Loader, Plus, Calendar as CalendarIcon, Settings, User, Users, FileText, Filter, RefreshCw, 
//     Edit2, Save, XCircle, CheckCircle, ChevronRight 
// } from 'lucide-react';
// import './LeavesManagment.css'; 

// // //     // Data States
// // //     const [stats, setStats] = useState({ allocated: 0, used: 0, remaining: 0 });
// // //     const [userBalances, setUserBalances] = useState([]); 
// // //     const [leaveRequests, setLeaveRequests] = useState([]);
// // //     const [leaveTypes, setLeaveTypes] = useState([]); 
// // //     const [policies, setPolicies] = useState([]); 
// // //     const [employees, setEmployees] = useState([]);
// // //     const [selectedEmployee, setSelectedEmployee] = useState(null);

// // //     // UI States
// // //     const [showApplyModal, setShowApplyModal] = useState(false);
// // //     const [statusFilter, setStatusFilter] = useState('');
// // //     const [message, setMessage] = useState({ text: '', type: '' });
// // //     const [savingPolicy, setSavingPolicy] = useState(false);

// // //     // Forms
// // //     const [applyFormData, setApplyFormData] = useState({ 
// // //         leaveMasterId: '', startDate: '', endDate: '', reason: '' 
// // //     });
// // //     const [errors, setErrors] = useState({});

// // //     // Inline Policy Editing
// // //     const [editingPolicyId, setEditingPolicyId] = useState(null);
// // //     const [policyFormData, setPolicyFormData] = useState({
// // //         daysAllowed: 0,
// // //         carryForward: false,
// // //         description: '',
// // //         leaveMasterId: null
// // //     });

// // //     const APPROVER_ROLES = ['SUPER_ADMIN', 'ADMIN', 'HR'];

// // //     const getAuthHeader = () => {
// // //         const token = localStorage.getItem('zTaskAuthToken');
// // //         return { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } };
// // //     };

// // //     const getUserDetails = () => {
// // //         try {
// // //             const stored = localStorage.getItem('zTaskUserDetails');
// // //             if (stored) {
// // //                 const parsed = JSON.parse(stored);
// // //                 const role = parsed.role?.name ? parsed.role.name.toUpperCase() : 'OTHER';
// // //                 return { role, name: parsed.name || 'User', id: parsed.id || null };
// // //             }
// // //         } catch (e) { console.error(e); }
// // //         return { role: 'OTHER', name: 'User', id: null };
// // //     };

// // //     const showMessage = (text, type = 'success') => {
// // //         setMessage({ text, type });
// // //         setTimeout(() => setMessage({ text: '', type: '' }), 4000);
// // //     };

// // //     // --- Load All Data ---
// // //     const loadData = async () => {
// // //         setLoading(true);
// // //         const authHeader = getAuthHeader();
// // //         const apiUrl = API_URL;

// // //         try {
// // //             // 1. Fetch Leave Types
// // //             const leaveTypeRes = await axios.get(
// // //                 'https://nodejs-prod.zasya.online/api/get-column/common_master/leave_type',
// // //                 authHeader
// // //             );
// // //             const formattedLeaveTypes = (leaveTypeRes.data || []).map(item => ({
// // //                 id: parseInt(item.id),
// // //                 value: item.value
// // //             }));
// // //             setLeaveTypes(formattedLeaveTypes);

// // //             const userInfo = getUserDetails();
// // //             setUserRole(userInfo.role);
// // //             setUserName(userInfo.name);

// // //             // Fetch generic data
// // //             const requests = [
// // //                 axios.get(`${apiUrl}/leave/summary`, authHeader), // My Summary
// // //                 axios.get(`${apiUrl}/leave/requests`, authHeader) // All Requests (if admin) or My Requests
// // //             ];

// // //             if (APPROVER_ROLES.includes(userInfo.role)) {
// // //                 requests.push(axios.get(`${apiUrl}/leave/policy`, authHeader));
// // //                 requests.push(axios.get(`${apiUrl}/hr/employees`, authHeader));
// // //             }

// // //             const responses = await Promise.all(requests);

// // //             const summaryData = responses[0].data;
// // //             setStats(summaryData.stats || { allocated: 0, used: 0, remaining: 0 });
// // //             setUserBalances(summaryData.balances || []); 

// // //             setLeaveRequests(responses[1].data);

// // //             let idx = 2;
// // //             if (APPROVER_ROLES.includes(userInfo.role)) {
// // //                 setPolicies(responses[idx++].data || []);
// // //                 setEmployees(responses[idx].data?.data || []);
// // //             }
// // //         } catch (err) {
// // //             console.error("Load error:", err);
// // //             showMessage("Failed to load data.", "error");
// // //         } finally {
// // //             setLoading(false);
// // //         }
// // //     };

// // //     useEffect(() => { loadData(); }, []);

// // //     // --- Load INDIVIDUAL Employee Details ---
// // //     const loadEmployeeDetails = async (emp) => {
// // //         try {
// // //             // We pass ?userId=ID here. The Backend Controller Update handles this now.
// // //             const [summaryRes, reqRes] = await Promise.all([
// // //                 axios.get(`http://localhost:5000/api/leave/summary?userId=${emp.id}`, getAuthHeader()),
// // //                 axios.get(`http://localhost:5000/api/leave/requests?userId=${emp.id}`, getAuthHeader())
// // //             ]);

// // //             setSelectedEmployee({
// // //                 ...emp,
// // //                 leaveHistory: reqRes.data, // This will now contain ONLY this user's requests
// // //                 leaveStats: summaryRes.data.stats,
// // //                 leaveBalances: summaryRes.data.balances 
// // //             });
// // //         } catch (err) {
// // //             console.error(err);
// // //             showMessage("Failed to load employee data.", "error");
// // //         }
// // //     };

// // //     // --- DYNAMIC OPTION CALCULATION ---
// // //     const availableLeaveOptions = leaveTypes.map(type => {
// // //         const balanceRecord = userBalances.find(b => b.leave_master_id === type.id);
// // //         const remaining = balanceRecord ? parseFloat(balanceRecord.remaining_days) : 0;

// // //         return {
// // //             ...type,
// // //             daysAvailable: remaining,
// // //             isAvailable: remaining > 0 
// // //         };
// // //     });

// // //     const validateApply = () => {
// // //         const err = {};
// // //         if (!applyFormData.leaveMasterId) err.policy = "Please select a leave type";
// // //         if (!applyFormData.startDate) err.startDate = "Start date is required";
// // //         if (!applyFormData.endDate) err.endDate = "End date is required";
// // //         if (applyFormData.reason || applyFormData.reason.trim().length < 5) {
// // //              // pass
// // //         } else {
// // //              err.reason = "Reason is required (min 5 chars)";
// // //         }

// // //         setErrors(err);
// // //         return Object.keys(err).length === 0;
// // //     };

// // //     const handleApplySubmit = async (e) => {
// // //         e.preventDefault();
// // //         if (!validateApply()) return;

// // //         const userInfo = getUserDetails();
// // //         const days = Math.ceil(
// // //             (new Date(applyFormData.endDate) - new Date(applyFormData.startDate)) / 86400000
// // //         ) + 1;

// // //         try {
// // //             await axios.post(
// // //                 'http://localhost:5000/api/leave/request',
// // //                 { 
// // //                     leaveMasterId: applyFormData.leaveMasterId,
// // //                     startDate: applyFormData.startDate,
// // //                     endDate: applyFormData.endDate,
// // //                     reason: applyFormData.reason,
// // //                     totalDays: days,
// // //                     userId: userInfo.id
// // //                 },
// // //                 getAuthHeader()
// // //             );
// // //             showMessage("Leave request submitted successfully!");
// // //             setShowApplyModal(false);
// // //             setApplyFormData({ leaveMasterId: '', startDate: '', endDate: '', reason: '' });
// // //             setErrors({});
// // //             loadData();
// // //         } catch (err) {
// // //             showMessage(err.response?.data?.message || "Failed to submit leave request.", "error");
// // //         }
// // //     };

// // //     const updateStatus = async (id, status) => {
// // //         try {
// // //             await axios.put(`http://localhost:5000/api/leave/request/${id}/status`, { status }, getAuthHeader());
// // //             showMessage(`Leave ${status} successfully!`);
// // //             loadData(); // Refreshes the main list
// // //             if (selectedEmployee) {
// // //                 // If viewing a specific employee, reload their details to update status there too
// // //                 loadEmployeeDetails(selectedEmployee);
// // //             }
// // //         } catch (err) { showMessage("Failed to update status.", "error"); }
// // //     };

// // //     const savePolicy = async () => {
// // //         setSavingPolicy(true);
// // //         try {
// // //             const data = {
// // //                 leaveMasterId: Number(policyFormData.leaveMasterId),
// // //                 daysAllowed: Number(policyFormData.daysAllowed),
// // //                 description: policyFormData.description || '',
// // //                 carryForward: Boolean(policyFormData.carryForward)
// // //             };
// // //             const existing = policies.find(p => Number(p.leave_master_id) === Number(data.leaveMasterId));

// // //             if (existing?.id) {
// // //                 await axios.put(`http://localhost:5000/api/leave/policy/${existing.id}`, data, getAuthHeader());
// // //             } else {
// // //                 await axios.post('http://localhost:5000/api/leave/policy', data, getAuthHeader());
// // //             }

// // //             const policyRes = await axios.get('http://localhost:5000/api/leave/policy', getAuthHeader());
// // //             setPolicies(policyRes.data || []);
// // //             showMessage("Policy saved successfully!");
// // //             setEditingPolicyId(null);
// // //             setPolicyFormData({ daysAllowed: 0, carryForward: false, description: '', leaveMasterId: null });
// // //         } catch (err) { showMessage("Failed to save policy.", "error"); } 
// // //         finally { setSavingPolicy(false); }
// // //     };

// // //     const mergedPolicies = leaveTypes.map(type => {
// // //         const pol = policies.find(p => Number(p.leave_master_id) === Number(type.id)) || {};
// // //         return {
// // //             ...type, ...pol, id: pol.id || null, days_allowed: pol.days_allowed ?? 0,
// // //             carry_forward: pol.carry_forward ?? false, description: pol.description || '',
// // //             leaveMasterId: Number(type.id), policy_name: pol.policy_name || type.value,
// // //             created_date: pol.created_date || (pol.created_at ? new Date(pol.created_at).toLocaleDateString() : null)
// // //         };
// // //     });

// // //     if (loading) return <div className="loader-full"><Loader className="spin" size={48} /><p>Loading...</p></div>;

// // //     return (
// // //         <div className="leaves-management-scope">
// // //             {message.text && <div className={`toast ${message.type}`}>{message.type === 'success' ? <CheckCircle size={20}/> : <XCircle size={20}/>}<span>{message.text}</span></div>}

// // //             <div className="page-container">
// // //                 <header className="page-header">
// // //                     <div className="header-left">
// // //                         <h1>Leave Portal</h1>
// // //                         <div className="user-info"><User size={14} />{userName} ({userRole})</div>
// // //                     </div>
// // //                     <div className="header-right">
// // //                         <div className="tabs">
// // //                             <button className={view === 'list' ? 'active' : ''} onClick={() => { setView('list'); setSelectedEmployee(null); }}><FileText size={16} /> Requests</button>
// // //                             <button className={view === 'calendar' ? 'active' : ''} onClick={() => setView('calendar')}><CalendarIcon size={16} /> Calendar</button>
// // //                             {(userRole === 'ADMIN' || userRole === 'SUPER_ADMIN') && <button className={view === 'policies' ? 'active' : ''} onClick={() => setView('policies')}><Settings size={16} /> Policies</button>}
// // //                             {APPROVER_ROLES.includes(userRole) && <button className={view === 'employees' ? 'active' : ''} onClick={() => { setView('employees'); setSelectedEmployee(null); }}><Users size={16} /> Employees</button>}
// // //                         </div>
// // //                         <button className="btn-apply" onClick={() => setShowApplyModal(true)}><Plus size={16} /> Apply</button>
// // //                         <button className="btn-refresh" onClick={loadData}><RefreshCw size={16} /></button>
// // //                     </div>
// // //                 </header>

// // //                 {/* List View */}
// // //                 {view === 'list' && !selectedEmployee && (
// // //                     <>
// // //                         <div className="stats-grid">
// // //                             <div className="stat-card"><div className="icon blue"><FileText size={24} /></div><div><p>Total Entitled</p><h3>{stats.allocated}</h3></div></div>
// // //                             <div className="stat-card"><div className="icon purple"><CheckCircle size={24} /></div><div><p>Used</p><h3>{stats.used}</h3></div></div>
// // //                             <div className="stat-card"><div className="icon green"><User size={24} /></div><div><p>Remaining</p><h3>{stats.remaining}</h3></div></div>
// // //                         </div>

// // //                         {/* Balance Breakdown Row */}
// // //                         <div className="balance-breakdown-row" style={{ display: 'flex', gap: '12px', marginBottom: '24px', flexWrap: 'wrap' }}>
// // //                              {userBalances.map(b => {
// // //                                  const leaveName = leaveTypes.find(t => t.id === b.leave_master_id)?.value || b.leave_type || 'Leave';
// // //                                  return (
// // //                                      <div key={b.leave_master_id} className="balance-pill" style={{ 
// // //                                          background: '#ffffff', padding: '10px 18px', borderRadius: '12px', border: '1px solid #e2e8f0', 
// // //                                          fontSize: '13px', fontWeight: '600', color: '#1e293b', boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
// // //                                          display: 'flex', alignItems: 'center', gap: '8px'
// // //                                      }}>
// // //                                          <span style={{ color: '#64748b', fontWeight: '500' }}>{leaveName}:</span>
// // //                                          <span style={{ color: b.remaining_days > 0 ? '#10b981' : '#ef4444', fontWeight: '700' }}>{b.remaining_days} days</span>
// // //                                      </div>
// // //                                  );
// // //                              })}
// // //                         </div>

// // //                         <div className="card">
// // //                             <div className="card-header">
// // //                                 <h3>Recent Requests</h3>
// // //                                 <div className="filter"><Filter size={16} /><select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}><option value="">All</option><option value="pending">Pending</option><option value="approved">Approved</option><option value="rejected">Rejected</option></select></div>
// // //                             </div>
// // //                             <table className="table">
// // //                                 <thead><tr><th>Employee</th><th>Type</th><th>Dates</th><th>Days</th><th>Status</th>{APPROVER_ROLES.includes(userRole) && <th>Actions</th>}</tr></thead>
// // //                                 <tbody>
// // //                                     {leaveRequests.filter(r => !statusFilter || r.status === statusFilter).map(r => {
// // //                                         const leaveName = leaveTypes.find(t => t.id === r.leaveTypeId)?.value || r.type || 'Leave';
// // //                                         return (
// // //                                             <tr key={r.id}>
// // //                                                 <td><div className="employee"><div className="avatar">{r.employee_name?.[0]}</div><div><div className="name">{r.employee_name}</div></div></div></td>
// // //                                                 <td><span className="type-badge">{leaveName}</span></td>
// // //                                                 <td>{r.start_date} → {r.end_date}</td>
// // //                                                 <td>{r.days}</td>
// // //                                                 <td><span className={`status ${r.status}`}>{r.status}</span></td>
// // //                                                 {APPROVER_ROLES.includes(userRole) && r.status === 'pending' && (
// // //                                                     <td>
// // //                                                         <button onClick={() => updateStatus(r.id, 'approved')} className="btn-small approve"><CheckCircle size={16} /></button>
// // //                                                         <button onClick={() => updateStatus(r.id, 'rejected')} className="btn-small reject"><XCircle size={16} /></button>
// // //                                                     </td>
// // //                                                 )}
// // //                                             </tr>
// // //                                         )
// // //                                     })}
// // //                                 </tbody>
// // //                             </table>
// // //                         </div>
// // //                     </>
// // //                 )}

// // //                 {/* Employees View */}
// // //                 {view === 'employees' && APPROVER_ROLES.includes(userRole) && !selectedEmployee && (
// // //                     <div className="card">
// // //                         <div className="card-header"><h3>All Employees</h3></div>
// // //                         <table className="table">
// // //                             <thead><tr><th>Name</th><th>Emp Code</th><th>Email</th><th>Dept</th><th>Status</th><th>Action</th></tr></thead>
// // //                             <tbody>
// // //                                 {employees.map(emp => (
// // //                                     <tr key={emp.id} className="clickable-row" onClick={() => loadEmployeeDetails(emp)}>
// // //                                         <td><div className="employee"><div className="avatar">{emp.first_name?.[0]}</div><div className="name">{emp.first_name} {emp.last_name}</div></div></td>
// // //                                         <td>{emp.emp_code}</td><td>{emp.email}</td><td>{emp.department_name}</td>
// // //                                         <td><span className={`status ${emp.status_name?.toLowerCase()}`}>{emp.status_name}</span></td>
// // //                                         <td><button className="btn-small"><ChevronRight size={18} /></button></td>
// // //                                     </tr>
// // //                                 ))}
// // //                             </tbody>
// // //                         </table>
// // //                     </div>
// // //                 )}

// // //                 {/* Selected Employee Detail */}
// // //                 {selectedEmployee && (
// // //                     <div className="card">
// // //                         <div className="card-header"><button onClick={() => setSelectedEmployee(null)} className="btn-back">← Back</button><h3>{selectedEmployee.first_name}'s Leaves</h3></div>
// // //                         <div className="employee-detail">
// // //                             <div className="stats-grid">
// // //                                 <div className="stat-card"><div><p>Total</p><h3>{selectedEmployee.leaveStats?.allocated || 0}</h3></div></div>
// // //                                 <div className="stat-card"><div><p>Used</p><h3>{selectedEmployee.leaveStats?.used || 0}</h3></div></div>
// // //                                 <div className="stat-card"><div><p>Rem</p><h3>{selectedEmployee.leaveStats?.remaining || 0}</h3></div></div>
// // //                             </div>

// // //                             <h4 style={{marginTop: '15px'}}>Balances</h4>
// // //                             <div style={{display:'flex', gap:'10px', marginBottom:'20px'}}>
// // //                                 {(selectedEmployee.leaveBalances || []).map(b => {
// // //                                     const leaveName = leaveTypes.find(t => t.id === b.leave_master_id)?.value || b.leave_type || 'Leave';
// // //                                     return (
// // //                                         <span key={b.leave_master_id} style={{background:'#f3f4f6', padding:'5px 10px', borderRadius:'5px', fontSize:'12px'}}>
// // //                                             {leaveName}: <b>{b.remaining_days}</b>
// // //                                         </span>
// // //                                     )
// // //                                 })}
// // //                             </div>

// // //                             <table className="table">
// // //                                 <thead><tr><th>Type</th><th>Dates</th><th>Days</th><th>Status</th></tr></thead>
// // //                                 <tbody>
// // //                                     {selectedEmployee.leaveHistory?.length > 0 ? selectedEmployee.leaveHistory.map(r => {
// // //                                         const leaveName = leaveTypes.find(t=>t.id === r.leaveTypeId)?.value || r.type || 'Leave';
// // //                                         return (
// // //                                             <tr key={r.id}>
// // //                                                 <td>{leaveName}</td>
// // //                                                 <td>{r.start_date} → {r.end_date}</td><td>{r.days}</td>
// // //                                                 <td><span className={`status ${r.status}`}>{r.status}</span></td>
// // //                                             </tr>
// // //                                         )
// // //                                     }) : (
// // //                                         <tr><td colSpan="4" style={{textAlign:'center', color:'#999'}}>No leave requests found for this user.</td></tr>
// // //                                     )}
// // //                                 </tbody>
// // //                             </table>
// // //                         </div>
// // //                     </div>
// // //                 )}

// // //                 {/* Policies View */}
// // //                 {view === 'policies' && (userRole === 'ADMIN' || userRole === 'SUPER_ADMIN') && (
// // //                     <div className="card">
// // //                         <div className="card-header"><h3>Policy Config</h3></div>
// // //                         <table className="table">
// // //                             <thead><tr><th>Name</th><th>Days</th><th>C/F</th><th>Desc</th><th>Created</th><th>Actions</th></tr></thead>
// // //                             <tbody>
// // //                                 {mergedPolicies.map(pol => {
// // //                                     const isEditing = editingPolicyId === pol.leaveMasterId;
// // //                                     return (
// // //                                         <tr key={pol.leaveMasterId}>
// // //                                             <td>{pol.policy_name}</td>
// // //                                             <td>{isEditing ? <input type="number" min="0" value={policyFormData.daysAllowed} onChange={e=>setPolicyFormData({...policyFormData, daysAllowed:e.target.value})} className="input-inline" /> : <strong>{pol.days_allowed}</strong>}</td>
// // //                                             <td>{isEditing ? <input type="checkbox" checked={policyFormData.carryForward} onChange={e=>setPolicyFormData({...policyFormData, carryForward:e.target.checked})} /> : (pol.carry_forward ? "Yes" : "No")}</td>
// // //                                             <td>{isEditing ? <input type="text" value={policyFormData.description} onChange={e=>setPolicyFormData({...policyFormData, description:e.target.value})} className="input-inline" /> : pol.description}</td>
// // //                                             <td>{pol.created_date}</td>
// // //                                             <td>
// // //                                                 {isEditing ? (
// // //                                                     <><button onClick={savePolicy} className="btn-small save"><Save size={16}/></button><button onClick={()=>setEditingPolicyId(null)} className="btn-small cancel"><XCircle size={16}/></button></>
// // //                                                 ) : (
// // //                                                     <button onClick={()=>{ setEditingPolicyId(pol.leaveMasterId); setPolicyFormData({ daysAllowed:pol.days_allowed, carryForward:pol.carry_forward, description:pol.description, leaveMasterId: pol.leaveMasterId }); }} className="btn-small edit"><Edit2 size={16}/></button>
// // //                                                 )}
// // //                                             </td>
// // //                                         </tr>
// // //                                     )
// // //                                 })}
// // //                             </tbody>
// // //                         </table>
// // //                     </div>
// // //                 )}

// // //                 {/* Apply Leave Modal */}
// // //                 {showApplyModal && (
// // //                     <div className="modal-overlay" onClick={() => setShowApplyModal(false)}>
// // //                         <div className="modal" onClick={e => e.stopPropagation()}>
// // //                             <h3>New Leave Request</h3>
// // //                             <form onSubmit={handleApplySubmit}>
// // //                                 <div className="form-group">
// // //                                     <label>Leave Type</label>
// // //                                     <select 
// // //                                         value={applyFormData.leaveMasterId} 
// // //                                         onChange={e => setApplyFormData({...applyFormData, leaveMasterId: e.target.value})} 
// // //                                         required
// // //                                     >
// // //                                         <option value="">Select Leave Type</option>
// // //                                         {availableLeaveOptions.map(type => (
// // //                                             <option key={type.id} value={type.id} disabled={!type.isAvailable}>
// // //                                                 {type.value} ({type.daysAvailable} Days Available)
// // //                                             </option>
// // //                                         ))}
// // //                                     </select>
// // //                                     {errors.policy && <span className="error">{errors.policy}</span>}
// // //                                 </div>
// // //                                 <div className="form-row">
// // //                                     <div className="form-group">
// // //                                         <label>Start Date</label>
// // //                                         <input type="date" value={applyFormData.startDate} onChange={e => setApplyFormData({...applyFormData, startDate: e.target.value})} required />
// // //                                         {errors.startDate && <span className="error">{errors.startDate}</span>}
// // //                                     </div>
// // //                                     <div className="form-group">
// // //                                         <label>End Date</label>
// // //                                         <input type="date" value={applyFormData.endDate} onChange={e => setApplyFormData({...applyFormData, endDate: e.target.value})} required />
// // //                                         {errors.endDate && <span className="error">{errors.endDate}</span>}
// // //                                     </div>
// // //                                 </div>
// // //                                 {errors.dates && <span className="error block">{errors.dates}</span>}
// // //                                 <div className="form-group">
// // //                                     <label>Reason</label>
// // //                                     <textarea rows="3" value={applyFormData.reason} onChange={e => setApplyFormData({...applyFormData, reason: e.target.value})} required />
// // //                                     {errors.reason && <span className="error">{errors.reason}</span>}
// // //                                 </div>
// // //                                 <button type="submit" className="btn-primary full">Submit Request</button>
// // //                             </form>
// // //                         </div>
// // //                     </div>
// // //                 )}
// // //             </div>
// // //         </div>
// // //     );
// // // };

// // // export default LeavesManagment;




// // import React, { useState, useEffect } from 'react';
// // import axios from 'axios';
// // import { 
// //     Loader, Plus, Calendar as CalendarIcon, Settings, User, Users, FileText, Filter, RefreshCw, 
// //     Edit2, Save, XCircle, CheckCircle, ChevronRight, Clock, Info, AlertCircle 
// // } from 'lucide-react';
// // import './LeavesManagment.css'; 

// // const LeavesManagment = () => {
// //     const [view, setView] = useState('list');
// //     const [userRole, setUserRole] = useState('OTHER');
// //     const [userName, setUserName] = useState('');
// //     const [loading, setLoading] = useState(true);

// //     // Loading States for Actions
// //     const [submitting, setSubmitting] = useState(false);
// //     const [actionLoading, setActionLoading] = useState(null); // Holds ID of request being approved/rejected

// //     // Data States
// //     const [stats, setStats] = useState({ allocated: 0, used: 0, pending: 0, remaining: 0 });
// //     const [userBalances, setUserBalances] = useState([]); 
// //     const [leaveRequests, setLeaveRequests] = useState([]);
// //     const [leaveTypes, setLeaveTypes] = useState([]); 
// //     const [policies, setPolicies] = useState([]); 
// //     const [employees, setEmployees] = useState([]);
// //     const [selectedEmployee, setSelectedEmployee] = useState(null);

// //     // UI States
// //     const [showApplyModal, setShowApplyModal] = useState(false);
// //     const [showRejectModal, setShowRejectModal] = useState(false);

// //     // Forms
// //     const [rejectData, setRejectData] = useState({ id: null, reason: '' }); 
// //     const [statusFilter, setStatusFilter] = useState('');
// //     const [message, setMessage] = useState({ text: '', type: '' });

// //     const [applyFormData, setApplyFormData] = useState({ 
// //         leaveMasterId: '', startDate: '', endDate: '', reason: '' 
// //     });
// //     const [errors, setErrors] = useState({});

// //     // Inline Policy Editing
// //     const [editingPolicyId, setEditingPolicyId] = useState(null);
// //     const [policyFormData, setPolicyFormData] = useState({
// //         daysAllowed: 0, carryForward: false, description: '', leaveMasterId: null
// //     });

// //     const APPROVER_ROLES = ['SUPER_ADMIN', 'ADMIN', 'HR'];

// //     const getAuthHeader = () => {
// //         const token = localStorage.getItem('zTaskAuthToken');
// //         return { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } };
// //     };

// //     const getUserDetails = () => {
// //         try {
// //             const stored = localStorage.getItem('zTaskUserDetails');
// //             if (stored) {
// //                 const parsed = JSON.parse(stored);
// //                 const role = parsed.role?.name ? parsed.role.name.toUpperCase() : 'OTHER';
// //                 return { role, name: parsed.name || 'User', id: parsed.id || null };
// //             }
// //         } catch (e) { console.error(e); }
// //         return { role: 'OTHER', name: 'User', id: null };
// //     };

// //     const showMessage = (text, type = 'success') => {
// //         setMessage({ text, type });
// //         setTimeout(() => setMessage({ text: '', type: '' }), 4000);
// //     };

// //     const loadData = async () => {
// //         setLoading(true);
// //         const authHeader = getAuthHeader();
// //         const apiUrl = API_URL;

// //         try {
// //             // 1. Fetch Leave Types
// //             const leaveTypeRes = await axios.get(
// //                 'https://nodejs-prod.zasya.online/api/get-column/common_master/leave_type',
// //                 authHeader
// //             );
// //             const formattedLeaveTypes = (leaveTypeRes.data || []).map(item => ({
// //                 id: parseInt(item.id), value: item.value
// //             }));
// //             setLeaveTypes(formattedLeaveTypes);

// //             const userInfo = getUserDetails();
// //             setUserRole(userInfo.role);
// //             setUserName(userInfo.name);

// //             // 2. Fetch Generic Data
// //             const requests = [
// //                 axios.get(`${apiUrl}/leave/summary`, authHeader), 
// //                 axios.get(`${apiUrl}/leave/requests`, authHeader) 
// //             ];

// //             // 3. Fetch Admin Data if Role allows
// //             if (APPROVER_ROLES.includes(userInfo.role)) {
// //                 requests.push(axios.get(`${apiUrl}/leave/policy`, authHeader));
// //                 requests.push(axios.get(`${apiUrl}/hr/employees`, authHeader));
// //             }

// //             const responses = await Promise.all(requests);

// //             const summaryData = responses[0].data;
// //             setStats(summaryData.stats || { allocated: 0, used: 0, pending: 0, remaining: 0 });
// //             setUserBalances(summaryData.balances || []); 
// //             setLeaveRequests(responses[1].data);

// //             let idx = 2;
// //             if (APPROVER_ROLES.includes(userInfo.role)) {
// //                 setPolicies(responses[idx++].data || []);
// //                 setEmployees(responses[idx].data?.data || []);
// //             }
// //         } catch (err) {
// //             console.error("Load error:", err);
// //             showMessage("Failed to load data.", "error");
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     useEffect(() => { loadData(); }, []);

// //     const loadEmployeeDetails = async (emp) => {
// //         try {
// //             const [summaryRes, reqRes] = await Promise.all([
// //                 axios.get(`http://localhost:5000/api/leave/summary?userId=${emp.id}`, getAuthHeader()),
// //                 axios.get(`http://localhost:5000/api/leave/requests?userId=${emp.id}`, getAuthHeader())
// //             ]);
// //             setSelectedEmployee({
// //                 ...emp,
// //                 leaveHistory: reqRes.data,
// //                 leaveStats: summaryRes.data.stats,
// //                 leaveBalances: summaryRes.data.balances 
// //             });
// //         } catch (err) {
// //             showMessage("Failed to load employee data.", "error");
// //         }
// //     };

// //     // --- POLICY FUNCTIONS ---
// //     const savePolicy = async () => {
// //         try {
// //             const data = {
// //                 leaveMasterId: Number(policyFormData.leaveMasterId),
// //                 daysAllowed: Number(policyFormData.daysAllowed),
// //                 description: policyFormData.description || '',
// //                 carryForward: Boolean(policyFormData.carryForward)
// //             };

// //             // Check if policy exists to decide PUT or POST
// //             const existing = policies.find(p => Number(p.leave_master_id) === Number(data.leaveMasterId));

// //             if (existing?.id) {
// //                 await axios.put(`http://localhost:5000/api/leave/policy/${existing.id}`, data, getAuthHeader());
// //             } else {
// //                 await axios.post('http://localhost:5000/api/leave/policy', data, getAuthHeader());
// //             }

// //             // Refresh Policies
// //             const policyRes = await axios.get('http://localhost:5000/api/leave/policy', getAuthHeader());
// //             setPolicies(policyRes.data || []);

// //             showMessage("Policy saved successfully!");
// //             setEditingPolicyId(null);
// //             setPolicyFormData({ daysAllowed: 0, carryForward: false, description: '', leaveMasterId: null });
// //         } catch (err) { 
// //             console.error(err);
// //             showMessage("Failed to save policy.", "error"); 
// //         } 
// //     };

// //     // --- APPLY FUNCTIONS ---
// //     const validateApply = (daysRequested) => {
// //         const err = {};
// //         const start = new Date(applyFormData.startDate);
// //         const end = new Date(applyFormData.endDate);
// //         const now = new Date();
// //         now.setHours(0, 0, 0, 0);

// //         if (!applyFormData.leaveMasterId) err.policy = "Please select a leave type.";
// //         if (!applyFormData.startDate) err.startDate = "Start date is required.";
// //         else if (start < now) err.startDate = "Cannot apply for past dates.";

// //         if (!applyFormData.endDate) err.endDate = "End date is required.";
// //         else if (end < start) err.endDate = "End date cannot be before start date.";

// //         const selectedBalance = userBalances.find(b => b.leave_master_id === parseInt(applyFormData.leaveMasterId));
// //         const available = selectedBalance ? selectedBalance.remaining : 0;

// //         if (daysRequested > available) {
// //             err.policy = `Insufficient Balance. Only ${available} days available.`;
// //         }

// //         if (!applyFormData.reason || applyFormData.reason.trim().length < 5) {
// //              err.reason = "Reason is required (min 5 chars).";
// //         }

// //         setErrors(err);
// //         return Object.keys(err).length === 0;
// //     };

// //     const handleApplySubmit = async (e) => {
// //         e.preventDefault();
// //         const days = Math.ceil((new Date(applyFormData.endDate) - new Date(applyFormData.startDate)) / 86400000) + 1;
// //         if (!validateApply(days)) return;

// //         setSubmitting(true);
// //         const userInfo = getUserDetails();

// //         try {
// //             await axios.post('http://localhost:5000/api/leave/request', { 
// //                 leaveMasterId: parseInt(applyFormData.leaveMasterId),
// //                 startDate: applyFormData.startDate,
// //                 endDate: applyFormData.endDate,
// //                 reason: applyFormData.reason,
// //                 totalDays: days,
// //                 userId: userInfo.id
// //             }, getAuthHeader());

// //             showMessage("Leave request submitted successfully!");
// //             setShowApplyModal(false);
// //             setApplyFormData({ leaveMasterId: '', startDate: '', endDate: '', reason: '' });
// //             setErrors({});
// //             loadData();
// //         } catch (err) {
// //             showMessage(err.response?.data?.message || "Failed to submit leave request.", "error");
// //         } finally {
// //             setSubmitting(false);
// //         }
// //     };

// //     // --- APPROVAL / REJECTION LOGIC ---
// //     const handleApprove = async (id) => {
// //         setActionLoading(id);
// //         try {
// //             await axios.put(`http://localhost:5000/api/leave/request/${id}/status`, { status: 'approved' }, getAuthHeader());
// //             showMessage("Leave Approved!");
// //             loadData();
// //             if (selectedEmployee) loadEmployeeDetails(selectedEmployee);
// //         } catch (err) {
// //             showMessage("Failed to approve.", "error");
// //         } finally {
// //             setActionLoading(null);
// //         }
// //     };

// //     const handleRejectClick = (id) => {
// //         setRejectData({ id, reason: '' });
// //         setShowRejectModal(true);
// //     };

// //     const confirmReject = async () => {
// //         if (!rejectData.reason.trim()) {
// //             alert("Please provide a rejection reason.");
// //             return;
// //         }
// //         setShowRejectModal(false);
// //         setActionLoading(rejectData.id);

// //         try {
// //             await axios.put(`http://localhost:5000/api/leave/request/${rejectData.id}/status`, { 
// //                 status: 'rejected',
// //                 rejectionReason: rejectData.reason 
// //             }, getAuthHeader());
// //             showMessage("Leave Rejected.");
// //             loadData();
// //             if (selectedEmployee) loadEmployeeDetails(selectedEmployee);
// //         } catch (err) {
// //             showMessage("Failed to reject.", "error");
// //         } finally {
// //             setActionLoading(null);
// //         }
// //     };

// //     // Prepare Policies for Render (Merging with Leave Types)
// //     const mergedPolicies = leaveTypes.map(type => {
// //         const pol = policies.find(p => Number(p.leave_master_id) === Number(type.id)) || {};
// //         return {
// //             ...type, ...pol, id: pol.id || null, days_allowed: pol.days_allowed ?? 0,
// //             carry_forward: pol.carry_forward ?? false, description: pol.description || '',
// //             leaveMasterId: Number(type.id), policy_name: pol.policy_name || type.value,
// //             created_date: pol.created_date || (pol.created_at ? new Date(pol.created_at).toLocaleDateString() : null)
// //         };
// //     });

// //     if (loading) return <div className="loader-full"><Loader className="spin" size={48} /><p>Loading...</p></div>;

// //     return (
// //         <div className="leaves-management-scope">
// //             {message.text && <div className={`toast ${message.type}`}>{message.type === 'success' ? <CheckCircle size={20}/> : <XCircle size={20}/>}<span>{message.text}</span></div>}

// //             <div className="page-container">
// //                 <header className="page-header">
// //                     <div className="header-left">
// //                         <h1>Leave Portal</h1>
// //                         <div className="user-info"><User size={14} />{userName} ({userRole})</div>
// //                     </div>
// //                     <div className="header-right">
// //                         <div className="tabs">
// //                             <button className={view === 'list' ? 'active' : ''} onClick={() => { setView('list'); setSelectedEmployee(null); }}><FileText size={16} /> Requests</button>
// //                             <button className={view === 'calendar' ? 'active' : ''} onClick={() => setView('calendar')}><CalendarIcon size={16} /> Calendar</button>
// //                             {(userRole === 'ADMIN' || userRole === 'SUPER_ADMIN') && <button className={view === 'policies' ? 'active' : ''} onClick={() => setView('policies')}><Settings size={16} /> Policies</button>}
// //                             {APPROVER_ROLES.includes(userRole) && <button className={view === 'employees' ? 'active' : ''} onClick={() => { setView('employees'); setSelectedEmployee(null); }}><Users size={16} /> Employees</button>}
// //                         </div>
// //                         <button className="btn-apply" onClick={() => setShowApplyModal(true)}><Plus size={16} /> Apply</button>
// //                         <button className="btn-refresh" onClick={loadData}><RefreshCw size={16} /></button>
// //                     </div>
// //                 </header>

// //                 {/* List View */}
// //                 {view === 'list' && !selectedEmployee && (
// //                     <>
// //                         <div className="stats-grid">
// //                             <div className="stat-card"><div className="icon blue"><FileText size={24} /></div><div><p>Total Entitled</p><h3>{stats.allocated}</h3></div></div>
// //                             <div className="stat-card"><div className="icon purple"><CheckCircle size={24} /></div><div><p>Approved (Used)</p><h3>{stats.used}</h3></div></div>
// //                             <div className="stat-card"><div className="icon orange"><Clock size={24} /></div><div><p>Pending</p><h3>{stats.pending}</h3></div></div>
// //                             <div className="stat-card"><div className="icon green"><User size={24} /></div><div><p>Remaining</p><h3>{stats.remaining}</h3></div></div>
// //                         </div>

// //                         {/* Balance Pills - Fixed Label Issue */}
// //                         <div className="balance-breakdown-row" style={{ display: 'flex', gap: '12px', marginBottom: '24px', flexWrap: 'wrap' }}>
// //                              {userBalances.map(b => {
// //                                  // Fallback Logic: Try to find name in leaveTypes if b.leave_type is missing
// //                                  const leaveName = b.leave_type || leaveTypes.find(t => t.id === b.leave_master_id)?.value || 'Leave';

// //                                  return (
// //                                      <div key={b.leave_master_id} className="balance-pill" style={{ 
// //                                          background: '#ffffff', padding: '10px 18px', borderRadius: '12px', border: '1px solid #e2e8f0', 
// //                                          fontSize: '13px', fontWeight: '600', color: '#1e293b', boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
// //                                          display: 'flex', alignItems: 'center', gap: '8px'
// //                                      }}>
// //                                          <span style={{ color: '#64748b', fontWeight: '500' }}>{leaveName}:</span>
// //                                          <span style={{ color: b.remaining > 0 ? '#10b981' : '#ef4444', fontWeight: '700' }}>{b.remaining} avail</span>
// //                                      </div>
// //                                  );
// //                              })}
// //                         </div>

// //                         <div className="card">
// //                             <div className="card-header">
// //                                 <h3>Recent Requests</h3>
// //                                 <div className="filter"><Filter size={16} /><select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}><option value="">All</option><option value="pending">Pending</option><option value="approved">Approved</option><option value="rejected">Rejected</option></select></div>
// //                             </div>
// //                             <table className="table">
// //                                 <thead><tr><th>Employee</th><th>Type</th><th>Dates</th><th>Days</th><th>Status</th>{APPROVER_ROLES.includes(userRole) && <th>Actions</th>}</tr></thead>
// //                                 <tbody>
// //                                     {leaveRequests.filter(r => !statusFilter || r.status === statusFilter).map(r => {
// //                                         const leaveName = r.type || 'General Leave';
// //                                         const isActionProcessing = actionLoading === r.id;

// //                                         return (
// //                                             <tr key={r.id}>
// //                                                 <td><div className="employee"><div className="avatar">{r.employee_name?.[0]}</div><div><div className="name">{r.employee_name}</div></div></div></td>
// //                                                 <td><span className="type-badge">{leaveName}</span></td>
// //                                                 <td>{r.start_date} → {r.end_date}</td>
// //                                                 <td>{r.days}</td>
// //                                                 <td>
// //                                                     <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
// //                                                         <span className={`status ${r.status}`}>{r.status}</span>
// //                                                         {r.status === 'rejected' && r.rejection_reason && (
// //                                                             <div className="tooltip-container">
// //                                                                 <Info size={16} className="info-icon" />
// //                                                                 <span className="tooltip-text">{r.rejection_reason}</span>
// //                                                             </div>
// //                                                         )}
// //                                                     </div>
// //                                                 </td>
// //                                                 {APPROVER_ROLES.includes(userRole) && r.status === 'pending' && (
// //                                                     <td>
// //                                                         {isActionProcessing ? (
// //                                                             <Loader className="spin" size={16} color="#2563eb" />
// //                                                         ) : (
// //                                                             <>
// //                                                                 <button onClick={() => handleApprove(r.id)} className="btn-small approve"><CheckCircle size={18} /></button>
// //                                                                 <button onClick={() => handleRejectClick(r.id)} className="btn-small reject"><XCircle size={18} /></button>
// //                                                             </>
// //                                                         )}
// //                                                     </td>
// //                                                 )}
// //                                             </tr>
// //                                         )
// //                                     })}
// //                                 </tbody>
// //                             </table>
// //                         </div>
// //                     </>
// //                 )}

// //                 {/* Employees View */}
// //                 {view === 'employees' && APPROVER_ROLES.includes(userRole) && !selectedEmployee && (
// //                     <div className="card">
// //                         <div className="card-header"><h3>All Employees</h3></div>
// //                         <table className="table">
// //                             <thead><tr><th>Name</th><th>Emp Code</th><th>Email</th><th>Dept</th><th>Status</th><th>Action</th></tr></thead>
// //                             <tbody>
// //                                 {employees.map(emp => (
// //                                     <tr key={emp.id} className="clickable-row" onClick={() => loadEmployeeDetails(emp)}>
// //                                         <td><div className="employee"><div className="avatar">{emp.first_name?.[0]}</div><div className="name">{emp.first_name} {emp.last_name}</div></div></td>
// //                                         <td>{emp.emp_code}</td><td>{emp.email}</td><td>{emp.department_name}</td>
// //                                         <td><span className={`status ${emp.status_name?.toLowerCase()}`}>{emp.status_name}</span></td>
// //                                         <td><button className="btn-small"><ChevronRight size={18} /></button></td>
// //                                     </tr>
// //                                 ))}
// //                             </tbody>
// //                         </table>
// //                     </div>
// //                 )}

// //                 {/* Selected Employee Detail */}
// //                 {selectedEmployee && (
// //                     <div className="card">
// //                         <div className="card-header"><button onClick={() => setSelectedEmployee(null)} className="btn-back">← Back</button><h3>{selectedEmployee.first_name}'s Leaves</h3></div>
// //                         <div className="employee-detail">
// //                             <div className="stats-grid">
// //                                 <div className="stat-card"><div><p>Total</p><h3>{selectedEmployee.leaveStats?.allocated || 0}</h3></div></div>
// //                                 <div className="stat-card"><div><p>Pending</p><h3>{selectedEmployee.leaveStats?.pending || 0}</h3></div></div>
// //                                 <div className="stat-card"><div><p>Used</p><h3>{selectedEmployee.leaveStats?.used || 0}</h3></div></div>
// //                                 <div className="stat-card"><div><p>Rem</p><h3>{selectedEmployee.leaveStats?.remaining || 0}</h3></div></div>
// //                             </div>

// //                             <table className="table" style={{marginTop:'20px'}}>
// //                                 <thead><tr><th>Type</th><th>Dates</th><th>Days</th><th>Status</th></tr></thead>
// //                                 <tbody>
// //                                     {selectedEmployee.leaveHistory?.length > 0 ? selectedEmployee.leaveHistory.map(r => (
// //                                         <tr key={r.id}>
// //                                             <td>{r.type}</td>
// //                                             <td>{r.start_date} → {r.end_date}</td><td>{r.days}</td>
// //                                             <td>
// //                                                 <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
// //                                                     <span className={`status ${r.status}`}>{r.status}</span>
// //                                                     {r.status === 'rejected' && r.rejection_reason && (
// //                                                         <div className="tooltip-container">
// //                                                             <Info size={16} className="info-icon" />
// //                                                             <span className="tooltip-text">{r.rejection_reason}</span>
// //                                                         </div>
// //                                                     )}
// //                                                 </div>
// //                                             </td>
// //                                         </tr>
// //                                     )) : (<tr><td colSpan="4" style={{textAlign:'center', color:'#999'}}>No leave requests found.</td></tr>)}
// //                                 </tbody>
// //                             </table>
// //                         </div>
// //                     </div>
// //                 )}

// //                 {/* Policies View - Restored */}
// //                 {view === 'policies' && (userRole === 'ADMIN' || userRole === 'SUPER_ADMIN') && (
// //                     <div className="card">
// //                         <div className="card-header"><h3>Policy Configuration</h3></div>
// //                         <table className="table">
// //                             <thead><tr><th>Name</th><th>Days Allowed</th><th>Carry Forward</th><th>Description</th><th>Last Updated</th><th>Actions</th></tr></thead>
// //                             <tbody>
// //                                 {mergedPolicies.map(pol => {
// //                                     const isEditing = editingPolicyId === pol.leaveMasterId;
// //                                     return (
// //                                         <tr key={pol.leaveMasterId}>
// //                                             <td><strong>{pol.policy_name}</strong></td>
// //                                             <td>
// //                                                 {isEditing ? (
// //                                                     <input type="number" min="0" value={policyFormData.daysAllowed} onChange={e=>setPolicyFormData({...policyFormData, daysAllowed:e.target.value})} className="input-inline" style={{width:'80px', padding:'5px'}} />
// //                                                 ) : (
// //                                                     <span style={{fontWeight:'bold', color:'#2563eb'}}>{pol.days_allowed}</span>
// //                                                 )}
// //                                             </td>
// //                                             <td>
// //                                                 {isEditing ? (
// //                                                     <input type="checkbox" checked={policyFormData.carryForward} onChange={e=>setPolicyFormData({...policyFormData, carryForward:e.target.checked})} />
// //                                                 ) : (
// //                                                     <span className={pol.carry_forward ? 'status approved' : 'status rejected'} style={{fontSize:'10px'}}>
// //                                                         {pol.carry_forward ? "YES" : "NO"}
// //                                                     </span>
// //                                                 )}
// //                                             </td>
// //                                             <td>
// //                                                 {isEditing ? (
// //                                                     <input type="text" value={policyFormData.description} onChange={e=>setPolicyFormData({...policyFormData, description:e.target.value})} className="input-inline" />
// //                                                 ) : (
// //                                                     <span style={{color:'#64748b'}}>{pol.description || '-'}</span>
// //                                                 )}
// //                                             </td>
// //                                             <td>{pol.created_date || '-'}</td>
// //                                             <td>
// //                                                 {isEditing ? (
// //                                                     <>
// //                                                         <button onClick={savePolicy} className="btn-small save" title="Save"><Save size={18}/></button>
// //                                                         <button onClick={()=>setEditingPolicyId(null)} className="btn-small cancel" title="Cancel"><XCircle size={18}/></button>
// //                                                     </>
// //                                                 ) : (
// //                                                     <button onClick={()=>{ 
// //                                                         setEditingPolicyId(pol.leaveMasterId); 
// //                                                         setPolicyFormData({ 
// //                                                             daysAllowed: pol.days_allowed, 
// //                                                             carryForward: pol.carry_forward, 
// //                                                             description: pol.description, 
// //                                                             leaveMasterId: pol.leaveMasterId 
// //                                                         }); 
// //                                                     }} className="btn-small edit" title="Edit"><Edit2 size={18}/></button>
// //                                                 )}
// //                                             </td>
// //                                         </tr>
// //                                     )
// //                                 })}
// //                             </tbody>
// //                         </table>
// //                     </div>
// //                 )}

// //                 {/* Calendar View Placeholder (Can be expanded) */}
// //                 {view === 'calendar' && (
// //                      <div className="card" style={{padding:'50px', textAlign:'center', color:'#94a3b8'}}>
// //                         <CalendarIcon size={48} style={{marginBottom:'15px'}} />
// //                         <h3>Calendar View Coming Soon</h3>
// //                         <p>This feature will show team leaves in a calendar format.</p>
// //                      </div>
// //                 )}

// //                 {/* Apply Leave Modal */}
// //                 {showApplyModal && (
// //                     <div className="modal-overlay" onClick={() => setShowApplyModal(false)}>
// //                         <div className="modal" onClick={e => e.stopPropagation()}>
// //                             <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
// //                                 <h3>New Leave Request</h3>
// //                                 <button onClick={()=>setShowApplyModal(false)} style={{background:'none', border:'none', cursor:'pointer', padding:'1.5rem'}}><XCircle/></button>
// //                             </div>

// //                             <form onSubmit={handleApplySubmit}>
// //                                 <div className="form-group">
// //                                     <label>Select Leave Type</label>
// //                                     <div className="radio-group-container">
// //                                         {leaveTypes.map(type => {
// //                                             const balance = userBalances.find(b => b.leave_master_id === type.id);
// //                                             const remaining = balance ? balance.remaining : 0;
// //                                             const isDisabled = remaining <= 0;
// //                                             return (
// //                                                 <label key={type.id} className={`radio-option ${parseInt(applyFormData.leaveMasterId) === type.id ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}>
// //                                                     <div>
// //                                                         <input type="radio" name="leaveType" value={type.id} checked={parseInt(applyFormData.leaveMasterId) === type.id} onChange={e => setApplyFormData({...applyFormData, leaveMasterId: e.target.value})} disabled={isDisabled} />
// //                                                         <span>{type.value}</span>
// //                                                     </div>
// //                                                     <span>{remaining} Available</span>
// //                                                 </label>
// //                                             );
// //                                         })}
// //                                     </div>
// //                                     {errors.policy && <span className="error">{errors.policy}</span>}
// //                                 </div>

// //                                 <div className="form-row">
// //                                     <div className="form-group">
// //                                         <label>Start Date</label>
// //                                         <input type="date" value={applyFormData.startDate} onChange={e => setApplyFormData({...applyFormData, startDate: e.target.value})} required />
// //                                         {errors.startDate && <span className="error">{errors.startDate}</span>}
// //                                     </div>
// //                                     <div className="form-group">
// //                                         <label>End Date</label>
// //                                         <input type="date" value={applyFormData.endDate} onChange={e => setApplyFormData({...applyFormData, endDate: e.target.value})} required />
// //                                         {errors.endDate && <span className="error">{errors.endDate}</span>}
// //                                     </div>
// //                                 </div>

// //                                 <div className="form-group">
// //                                     <label>Reason</label>
// //                                     <textarea rows="3" value={applyFormData.reason} onChange={e => setApplyFormData({...applyFormData, reason: e.target.value})} required />
// //                                     {errors.reason && <span className="error">{errors.reason}</span>}
// //                                 </div>
// //                                 <button type="submit" className="btn-primary full" disabled={submitting}>
// //                                     {submitting ? <Loader className="spin" size={20} /> : "Submit Request"}
// //                                 </button>
// //                             </form>
// //                         </div>
// //                     </div>
// //                 )}

// //                 {/* Rejection Modal */}
// //                 {showRejectModal && (
// //                     <div className="modal-overlay" onClick={() => setShowRejectModal(false)}>
// //                         <div className="modal small-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '400px' }}>
// //                             <h3>Reject Request</h3>
// //                             <div style={{ padding: '0 1.5rem 1.5rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '15px' }}>
// //                                 <p style={{ fontSize: '0.9rem', color: '#64748b' }}>Please provide a reason for rejecting this leave request.</p>
// //                                 <textarea 
// //                                     rows="3" 
// //                                     className="input-textarea"
// //                                     placeholder="Reason for rejection..." 
// //                                     value={rejectData.reason} 
// //                                     onChange={e => setRejectData({ ...rejectData, reason: e.target.value })} 
// //                                     style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0' }}
// //                                 />
// //                                 <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
// //                                     <button onClick={() => setShowRejectModal(false)} className="btn-small cancel" style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #e2e8f0', background: 'white' }}>Cancel</button>
// //                                     <button onClick={confirmReject} className="btn-small" style={{ padding: '8px 16px', borderRadius: '6px', background: '#ef4444', color: 'white', border: 'none' }}>Reject</button>
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 )}
// //             </div>
// //         </div>
// //     );
// // };

// // export default LeavesManagment;



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { 
//     Loader, Plus, Calendar as CalendarIcon, Settings, User, Users, FileText, Filter, RefreshCw, 
//     Edit2, Save, XCircle, CheckCircle, ChevronRight, Clock, Info, ChevronLeft, AlertCircle 
// } from 'lucide-react';
// import './LeavesManagment.css'; 

// const LeavesManagment = () => {
//     const [view, setView] = useState('list'); // 'list', 'calendar', 'policies', 'employees'
//     const [userRole, setUserRole] = useState('OTHER');
//     const [userName, setUserName] = useState('');
//     const [loading, setLoading] = useState(true);

//     // Calendar State
//     const [currentDate, setCurrentDate] = useState(new Date());

//     // Loading States
//     const [submitting, setSubmitting] = useState(false);
//     const [actionLoading, setActionLoading] = useState(null);

//     // Data States
//     const [stats, setStats] = useState({ allocated: 0, used: 0, pending: 0, remaining: 0 });
//     const [userBalances, setUserBalances] = useState([]); 
//     const [leaveRequests, setLeaveRequests] = useState([]);
//     const [leaveTypes, setLeaveTypes] = useState([]); 
//     const [policies, setPolicies] = useState([]); 
//     const [employees, setEmployees] = useState([]);
//     const [selectedEmployee, setSelectedEmployee] = useState(null);

//     // UI States
//     const [showApplyModal, setShowApplyModal] = useState(false);
//     const [showRejectModal, setShowRejectModal] = useState(false);

//     // Forms
//     const [rejectData, setRejectData] = useState({ id: null, reason: '' }); 
//     const [statusFilter, setStatusFilter] = useState('');
//     const [message, setMessage] = useState({ text: '', type: '' });

//     const [applyFormData, setApplyFormData] = useState({ 
//         leaveMasterId: '', startDate: '', endDate: '', reason: '' 
//     });
//     const [errors, setErrors] = useState({});

//     // Inline Policy Editing
//     const [editingPolicyId, setEditingPolicyId] = useState(null);
//     const [policyFormData, setPolicyFormData] = useState({
//         daysAllowed: 0, carryForward: false, description: '', leaveMasterId: null
//     });

//     const APPROVER_ROLES = ['SUPER_ADMIN', 'ADMIN', 'HR'];

//     const getAuthHeader = () => {
//         const token = localStorage.getItem('zTaskAuthToken');
//         return { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } };
//     };

//     const getUserDetails = () => {
//         try {
//             const stored = localStorage.getItem('zTaskUserDetails');
//             if (stored) {
//                 const parsed = JSON.parse(stored);
//                 const role = parsed.role?.name ? parsed.role.name.toUpperCase() : 'OTHER';
//                 return { role, name: parsed.name || 'User', id: parsed.id || null };
//             }
//         } catch (e) { console.error(e); }
//         return { role: 'OTHER', name: 'User', id: null };
//     };

//     const showMessage = (text, type = 'success') => {
//         setMessage({ text, type });
//         setTimeout(() => setMessage({ text: '', type: '' }), 4000);
//     };

//     const loadData = async () => {
//         setLoading(true);
//         const authHeader = getAuthHeader();
//         const apiUrl = 'http://localhost:5000/api';

//         try {
//             // 1. Fetch Leave Types
//             const leaveTypeRes = await axios.get(
//                 'https://nodejs-prod.zasya.online/api/get-column/common_master/leave_type',
//                 authHeader
//             );
//             const formattedLeaveTypes = (leaveTypeRes.data || []).map(item => ({
//                 id: parseInt(item.id), value: item.value
//             }));
//             setLeaveTypes(formattedLeaveTypes);

//             const userInfo = getUserDetails();
//             setUserRole(userInfo.role);
//             setUserName(userInfo.name);

//             // 2. Fetch Generic Data
//             const requests = [
//                 axios.get(`${apiUrl}/leave/summary`, authHeader), 
//                 axios.get(`${apiUrl}/leave/requests`, authHeader) 
//             ];

//             // 3. Fetch Admin Data if Role allows
//             if (APPROVER_ROLES.includes(userInfo.role)) {
//                 requests.push(axios.get(`${apiUrl}/leave/policy`, authHeader));
//                 requests.push(axios.get(`${apiUrl}/hr/employees`, authHeader));
//             }

//             const responses = await Promise.all(requests);

//             const summaryData = responses[0].data;
//             setStats(summaryData.stats || { allocated: 0, used: 0, pending: 0, remaining: 0 });
//             setUserBalances(summaryData.balances || []); 
//             setLeaveRequests(responses[1].data);

//             let idx = 2;
//             if (APPROVER_ROLES.includes(userInfo.role)) {
//                 setPolicies(responses[idx++].data || []);
//                 setEmployees(responses[idx].data?.data || []);
//             }
//         } catch (err) {
//             console.error("Load error:", err);
//             showMessage("Failed to load data.", "error");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => { loadData(); }, []);

//     const loadEmployeeDetails = async (emp) => {
//         try {
//             const [summaryRes, reqRes] = await Promise.all([
//                 axios.get(`http://localhost:5000/api/leave/summary?userId=${emp.id}`, getAuthHeader()),
//                 axios.get(`http://localhost:5000/api/leave/requests?userId=${emp.id}`, getAuthHeader())
//             ]);
//             setSelectedEmployee({
//                 ...emp,
//                 leaveHistory: reqRes.data,
//                 leaveStats: summaryRes.data.stats,
//                 leaveBalances: summaryRes.data.balances 
//             });
//         } catch (err) {
//             showMessage("Failed to load employee data.", "error");
//         }
//     };

//     // --- CALENDAR LOGIC (ENHANCED) ---
//     const getDaysInMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
//     const getFirstDayOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1).getDay();

//     const prevMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
//     const nextMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));

//     const renderCalendar = () => {
//         const daysInMonth = getDaysInMonth(currentDate);
//         const firstDay = getFirstDayOfMonth(currentDate);
//         const days = [];

//         // Empty slots
//         for (let i = 0; i < firstDay; i++) {
//             days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
//         }

//         // Days
//         for (let day = 1; day <= daysInMonth; day++) {
//             const dateStr = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

//             // Filter leaves for this specific day
//             const dayLeaves = leaveRequests.filter(req => {
//                 if (req.status === 'rejected') return false; // Don't show rejected
//                 return dateStr >= req.start_date && dateStr <= req.end_date;
//             });

//             days.push(
//                 <div key={day} className={`calendar-day ${dayLeaves.length > 0 ? 'has-event' : ''}`}>
//                     <div className="day-number">{day}</div>
//                     <div className="day-events-container">
//                         {dayLeaves.map((l, idx) => {
//                              const shortName = l.employee_name?.split(' ')[0] || 'User';
//                              const leaveType = l.type || 'L';
//                              return (
//                                 <div key={`${day}-${idx}`} className={`calendar-event-pill status-${l.status}`}>
//                                     <div className="event-content">
//                                         <span className="event-name">{shortName}</span>
//                                         <span className="event-type">({leaveType})</span>
//                                     </div>

//                                     {/* Tooltip for Details */}
//                                     <div className="calendar-tooltip">
//                                         <strong>{l.employee_name}</strong>
//                                         <div className="tooltip-row"><span>Type:</span> {l.type}</div>
//                                         <div className="tooltip-row"><span>Status:</span> <span className={`status-text ${l.status}`}>{l.status}</span></div>
//                                         <div className="tooltip-row"><span>Reason:</span> {l.reason}</div>
//                                         <div className="tooltip-dates">{l.start_date} - {l.end_date}</div>
//                                     </div>
//                                 </div>
//                              );
//                         })}
//                     </div>
//                 </div>
//             );
//         }
//         return days;
//     };

//     // --- POLICY FUNCTIONS ---
//     const savePolicy = async () => {
//         try {
//             const data = {
//                 leaveMasterId: Number(policyFormData.leaveMasterId),
//                 daysAllowed: Number(policyFormData.daysAllowed),
//                 description: policyFormData.description || '',
//                 carryForward: Boolean(policyFormData.carryForward)
//             };

//             const existing = policies.find(p => Number(p.leave_master_id) === Number(data.leaveMasterId));

//             if (existing?.id) {
//                 await axios.put(`http://localhost:5000/api/leave/policy/${existing.id}`, data, getAuthHeader());
//             } else {
//                 await axios.post('http://localhost:5000/api/leave/policy', data, getAuthHeader());
//             }

//             const policyRes = await axios.get('http://localhost:5000/api/leave/policy', getAuthHeader());
//             setPolicies(policyRes.data || []);

//             showMessage("Policy saved successfully!");
//             setEditingPolicyId(null);
//             setPolicyFormData({ daysAllowed: 0, carryForward: false, description: '', leaveMasterId: null });
//         } catch (err) { 
//             showMessage("Failed to save policy.", "error"); 
//         } 
//     };

//     // --- APPLY FUNCTIONS ---
//     const validateApply = (daysRequested) => {
//         const err = {};
//         const start = new Date(applyFormData.startDate);
//         const end = new Date(applyFormData.endDate);
//         const now = new Date();
//         now.setHours(0, 0, 0, 0);

//         if (!applyFormData.leaveMasterId) err.policy = "Please select a leave type.";
//         if (!applyFormData.startDate) err.startDate = "Start date required.";
//         else if (start < now) err.startDate = "Cannot use past dates.";

//         if (!applyFormData.endDate) err.endDate = "End date required.";
//         else if (end < start) err.endDate = "End < Start.";

//         const selectedBalance = userBalances.find(b => b.leave_master_id === parseInt(applyFormData.leaveMasterId));
//         const available = selectedBalance ? selectedBalance.remaining : 0;

//         if (daysRequested > available) {
//             err.policy = `Insufficient Balance (${available} avail).`;
//         }

//         if (!applyFormData.reason || applyFormData.reason.trim().length < 5) {
//              err.reason = "Reason required (min 5 chars).";
//         }

//         setErrors(err);
//         return Object.keys(err).length === 0;
//     };

//     const handleApplySubmit = async (e) => {
//         e.preventDefault();
//         const days = Math.ceil((new Date(applyFormData.endDate) - new Date(applyFormData.startDate)) / 86400000) + 1;
//         if (!validateApply(days)) return;

//         setSubmitting(true);
//         const userInfo = getUserDetails();

//         try {
//             await axios.post('http://localhost:5000/api/leave/request', { 
//                 leaveMasterId: parseInt(applyFormData.leaveMasterId),
//                 startDate: applyFormData.startDate,
//                 endDate: applyFormData.endDate,
//                 reason: applyFormData.reason,
//                 totalDays: days,
//                 userId: userInfo.id
//             }, getAuthHeader());

//             showMessage("Leave request submitted!");
//             setShowApplyModal(false);
//             setApplyFormData({ leaveMasterId: '', startDate: '', endDate: '', reason: '' });
//             setErrors({});
//             loadData();
//         } catch (err) {
//             showMessage(err.response?.data?.message || "Failed.", "error");
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     // --- APPROVAL / REJECTION LOGIC ---
//     const handleApprove = async (id) => {
//         setActionLoading(id);
//         try {
//             await axios.put(`http://localhost:5000/api/leave/request/${id}/status`, { status: 'approved' }, getAuthHeader());
//             showMessage("Approved!");
//             loadData();
//             if (selectedEmployee) loadEmployeeDetails(selectedEmployee);
//         } catch (err) {
//             showMessage("Failed.", "error");
//         } finally {
//             setActionLoading(null);
//         }
//     };

//     const handleRejectClick = (id) => {
//         setRejectData({ id, reason: '' });
//         setShowRejectModal(true);
//     };

//     const confirmReject = async () => {
//         if (!rejectData.reason.trim()) {
//             alert("Enter rejection reason.");
//             return;
//         }
//         setShowRejectModal(false);
//         setActionLoading(rejectData.id);

//         try {
//             await axios.put(`http://localhost:5000/api/leave/request/${rejectData.id}/status`, { 
//                 status: 'rejected',
//                 rejectionReason: rejectData.reason 
//             }, getAuthHeader());
//             showMessage("Rejected.");
//             loadData();
//             if (selectedEmployee) loadEmployeeDetails(selectedEmployee);
//         } catch (err) {
//             showMessage("Failed.", "error");
//         } finally {
//             setActionLoading(null);
//         }
//     };

//     const mergedPolicies = leaveTypes.map(type => {
//         const pol = policies.find(p => Number(p.leave_master_id) === Number(type.id)) || {};
//         return {
//             ...type, ...pol, id: pol.id || null, days_allowed: pol.days_allowed ?? 0,
//             carry_forward: pol.carry_forward ?? false, description: pol.description || '',
//             leaveMasterId: Number(type.id), policy_name: pol.policy_name || type.value,
//             created_date: pol.created_date || (pol.created_at ? new Date(pol.created_at).toLocaleDateString() : null)
//         };
//     });

//     if (loading) return <div className="loader-full"><Loader className="spin" size={32} /><p>Loading...</p></div>;

//     return (
//         <div className="leaves-management-scope">
//             {message.text && <div className={`toast ${message.type}`}>{message.type === 'success' ? <CheckCircle size={16}/> : <XCircle size={16}/>}<span>{message.text}</span></div>}

//             <div className="page-container">
//                 <header className="page-header">
//                     <div className="header-left">
//                         <h1>Leave Portal</h1>
//                         <div className="user-info"><User size={12} />{userName} ({userRole})</div>
//                     </div>
//                     <div className="header-right">
//                         <div className="tabs">
//                             <button className={view === 'list' ? 'active' : ''} onClick={() => { setView('list'); setSelectedEmployee(null); }}><FileText size={14} /> Requests</button>
//                             <button className={view === 'calendar' ? 'active' : ''} onClick={() => setView('calendar')}><CalendarIcon size={14} /> Calendar</button>
//                             {(userRole === 'ADMIN' || userRole === 'SUPER_ADMIN') && <button className={view === 'policies' ? 'active' : ''} onClick={() => setView('policies')}><Settings size={14} /> Policies</button>}
//                             {APPROVER_ROLES.includes(userRole) && <button className={view === 'employees' ? 'active' : ''} onClick={() => { setView('employees'); setSelectedEmployee(null); }}><Users size={14} /> Employees</button>}
//                         </div>
//                         <button className="btn-apply" onClick={() => setShowApplyModal(true)}><Plus size={14} /> Apply</button>
//                         <button className="btn-refresh" onClick={loadData}><RefreshCw size={14} /></button>
//                     </div>
//                 </header>

//                 {/* List View */}
//                 {view === 'list' && !selectedEmployee && (
//                     <>
//                         <div className="stats-grid">
//                             <div className="stat-card"><div className="icon blue"><FileText size={20} /></div><div><p>Entitled</p><h3>{stats.allocated}</h3></div></div>
//                             <div className="stat-card"><div className="icon purple"><CheckCircle size={20} /></div><div><p>Used</p><h3>{stats.used}</h3></div></div>
//                             <div className="stat-card"><div className="icon orange"><Clock size={20} /></div><div><p>Pending</p><h3>{stats.pending}</h3></div></div>
//                             <div className="stat-card"><div className="icon green"><User size={20} /></div><div><p>Remaining</p><h3>{stats.remaining}</h3></div></div>
//                         </div>

//                         <div className="balance-breakdown-row" style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
//                              {userBalances.map(b => {
//                                  const leaveName = b.leave_type || leaveTypes.find(t => t.id === b.leave_master_id)?.value || 'Leave';
//                                  return (
//                                      <div key={b.leave_master_id} className="balance-pill">
//                                          <span className="bp-label">{leaveName}:</span>
//                                          <span className={`bp-val ${b.remaining > 0 ? 'good' : 'bad'}`}>{b.remaining} avail</span>
//                                      </div>
//                                  );
//                              })}
//                         </div>

//                         <div className="card">
//                             <div className="card-header">
//                                 <h3>Recent Requests</h3>
//                                 <div className="filter"><Filter size={14} /><select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}><option value="">All</option><option value="pending">Pending</option><option value="approved">Approved</option><option value="rejected">Rejected</option></select></div>
//                             </div>
//                             <table className="table">
//                                 <thead><tr><th>Employee</th><th>Type</th><th>Dates</th><th>Days</th><th>Status</th>{APPROVER_ROLES.includes(userRole) && <th>Actions</th>}</tr></thead>
//                                 <tbody>
//                                     {leaveRequests.filter(r => !statusFilter || r.status === statusFilter).map(r => {
//                                         const leaveName = r.type || 'General';
//                                         return (
//                                             <tr key={r.id}>
//                                                 <td><div className="employee"><div className="avatar">{r.employee_name?.[0]}</div><div className="name">{r.employee_name}</div></div></td>
//                                                 <td><span className="type-badge">{leaveName}</span></td>
//                                                 <td><span className="date-range">{r.start_date} → {r.end_date}</span></td>
//                                                 <td>{r.days}</td>
//                                                 <td>
//                                                     <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//                                                         <span className={`status ${r.status}`}>{r.status}</span>
//                                                         {r.status === 'rejected' && r.rejection_reason && (
//                                                             <div className="tooltip-container">
//                                                                 <Info size={14} className="info-icon" />
//                                                                 <span className="tooltip-text">{r.rejection_reason}</span>
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 </td>
//                                                 {APPROVER_ROLES.includes(userRole) && r.status === 'pending' && (
//                                                     <td>
//                                                         {actionLoading === r.id ? <Loader className="spin" size={14} color="#2563eb" /> : (
//                                                             <><button onClick={() => handleApprove(r.id)} className="btn-small approve"><CheckCircle size={16} /></button><button onClick={() => handleRejectClick(r.id)} className="btn-small reject"><XCircle size={16} /></button></>
//                                                         )}
//                                                     </td>
//                                                 )}
//                                             </tr>
//                                         )
//                                     })}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </>
//                 )}

//                 {/* Calendar View */}
//                 {view === 'calendar' && (
//                     <div className="card">
//                         <div className="calendar-header">
//                             <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
//                                 <CalendarIcon size={18} color="#2563eb"/>
//                                 <h3>{currentDate.toLocaleDateString('default', { month: 'long', year: 'numeric' })}</h3>
//                             </div>
//                             <div style={{display:'flex', gap:'5px'}}>
//                                 <button onClick={prevMonth} className="btn-nav"><ChevronLeft size={16}/></button>
//                                 <button onClick={nextMonth} className="btn-nav"><ChevronRight size={16}/></button>
//                             </div>
//                         </div>
//                         {/* Legend */}
//                         <div className="calendar-legend">
//                             <span className="legend-item"><span className="dot approved"></span> Approved</span>
//                             <span className="legend-item"><span className="dot pending"></span> Pending</span>
//                         </div>
//                         <div className="calendar-grid">
//                             {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => <div key={d} className="calendar-head">{d}</div>)}
//                             {renderCalendar()}
//                         </div>
//                     </div>
//                 )}

//                 {/* Employees View */}
//                 {view === 'employees' && APPROVER_ROLES.includes(userRole) && !selectedEmployee && (
//                     <div className="card">
//                         <div className="card-header"><h3>All Employees</h3></div>
//                         <table className="table">
//                             <thead><tr><th>Name</th><th>Code</th><th>Email</th><th>Dept</th><th>Status</th><th></th></tr></thead>
//                             <tbody>
//                                 {employees.map(emp => (
//                                     <tr key={emp.id} className="clickable-row" onClick={() => loadEmployeeDetails(emp)}>
//                                         <td><div className="employee"><div className="avatar">{emp.first_name?.[0]}</div><div className="name">{emp.first_name} {emp.last_name}</div></div></td>
//                                         <td>{emp.emp_code}</td><td>{emp.email}</td><td>{emp.department_name}</td>
//                                         <td><span className={`status ${emp.status_name?.toLowerCase()}`}>{emp.status_name}</span></td>
//                                         <td><button className="btn-small"><ChevronRight size={16} /></button></td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}

//                 {/* Selected Employee Detail */}
//                 {selectedEmployee && (
//                     <div className="card">
//                         <div className="card-header"><button onClick={() => setSelectedEmployee(null)} className="btn-back">← Back</button><h3>{selectedEmployee.first_name}'s Leaves</h3></div>
//                         <div className="employee-detail">
//                             <div className="stats-grid">
//                                 <div className="stat-card"><div><p>Total</p><h3>{selectedEmployee.leaveStats?.allocated || 0}</h3></div></div>
//                                 <div className="stat-card"><div><p>Pending</p><h3>{selectedEmployee.leaveStats?.pending || 0}</h3></div></div>
//                                 <div className="stat-card"><div><p>Used</p><h3>{selectedEmployee.leaveStats?.used || 0}</h3></div></div>
//                                 <div className="stat-card"><div><p>Rem</p><h3>{selectedEmployee.leaveStats?.remaining || 0}</h3></div></div>
//                             </div>
//                             <table className="table" style={{marginTop:'15px'}}>
//                                 <thead><tr><th>Type</th><th>Dates</th><th>Days</th><th>Status</th></tr></thead>
//                                 <tbody>
//                                     {selectedEmployee.leaveHistory?.length > 0 ? selectedEmployee.leaveHistory.map(r => (
//                                         <tr key={r.id}>
//                                             <td>{r.type}</td><td>{r.start_date} → {r.end_date}</td><td>{r.days}</td>
//                                             <td><span className={`status ${r.status}`}>{r.status}</span></td>
//                                         </tr>
//                                     )) : (<tr><td colSpan="4" style={{textAlign:'center', color:'#999'}}>No data.</td></tr>)}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 )}

//                 {/* Policies View */}
//                 {view === 'policies' && (userRole === 'ADMIN' || userRole === 'SUPER_ADMIN') && (
//                     <div className="card">
//                         <div className="card-header"><h3>Policy Config</h3></div>
//                         <table className="table">
//                             <thead><tr><th>Name</th><th>Days</th><th>C/F</th><th>Desc</th><th>Updated</th><th>Actions</th></tr></thead>
//                             <tbody>
//                                 {mergedPolicies.map(pol => {
//                                     const isEditing = editingPolicyId === pol.leaveMasterId;
//                                     return (
//                                         <tr key={pol.leaveMasterId}>
//                                             <td><strong>{pol.policy_name}</strong></td>
//                                             <td>{isEditing ? <input type="number" value={policyFormData.daysAllowed} onChange={e=>setPolicyFormData({...policyFormData, daysAllowed:e.target.value})} className="input-inline small" /> : pol.days_allowed}</td>
//                                             <td>{isEditing ? <input type="checkbox" checked={policyFormData.carryForward} onChange={e=>setPolicyFormData({...policyFormData, carryForward:e.target.checked})} /> : (pol.carry_forward ? "Y" : "N")}</td>
//                                             <td>{isEditing ? <input type="text" value={policyFormData.description} onChange={e=>setPolicyFormData({...policyFormData, description:e.target.value})} className="input-inline" /> : pol.description}</td>
//                                             <td>{pol.created_date}</td>
//                                             <td>
//                                                 {isEditing ? (
//                                                     <><button onClick={savePolicy} className="btn-small save"><Save size={16}/></button><button onClick={()=>setEditingPolicyId(null)} className="btn-small cancel"><XCircle size={16}/></button></>
//                                                 ) : (
//                                                     <button onClick={()=>{ setEditingPolicyId(pol.leaveMasterId); setPolicyFormData({ daysAllowed: pol.days_allowed, carryForward: pol.carry_forward, description: pol.description, leaveMasterId: pol.leaveMasterId }); }} className="btn-small edit"><Edit2 size={16}/></button>
//                                                 )}
//                                             </td>
//                                         </tr>
//                                     )
//                                 })}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}

//                 {/* Apply Modal */}
//                 {showApplyModal && (
//                     <div className="modal-overlay" onClick={() => setShowApplyModal(false)}>
//                         <div className="modal" onClick={e => e.stopPropagation()}>
//                             <div className="modal-head"><h3>New Request</h3><button onClick={()=>setShowApplyModal(false)}><XCircle size={18}/></button></div>
//                             <form onSubmit={handleApplySubmit}>
//                                 <div className="form-group">
//                                     <label>Leave Type</label>
//                                     <div className="radio-group-container">
//                                         {leaveTypes.map(type => {
//                                             const balance = userBalances.find(b => b.leave_master_id === type.id);
//                                             const remaining = balance ? balance.remaining : 0;
//                                             return (
//                                                 <label key={type.id} className={`radio-option ${parseInt(applyFormData.leaveMasterId) === type.id ? 'selected' : ''} ${remaining<=0 ? 'disabled' : ''}`}>
//                                                     <div><input type="radio" name="leaveType" value={type.id} checked={parseInt(applyFormData.leaveMasterId) === type.id} onChange={e => setApplyFormData({...applyFormData, leaveMasterId: e.target.value})} disabled={remaining<=0} /><span>{type.value}</span></div>
//                                                     <span>{remaining} Avail</span>
//                                                 </label>
//                                             );
//                                         })}
//                                     </div>
//                                     {errors.policy && <span className="error">{errors.policy}</span>}
//                                 </div>
//                                 <div className="form-row">
//                                     <div className="form-group"><label>Start</label><input type="date" value={applyFormData.startDate} onChange={e => setApplyFormData({...applyFormData, startDate: e.target.value})} required /></div>
//                                     <div className="form-group"><label>End</label><input type="date" value={applyFormData.endDate} onChange={e => setApplyFormData({...applyFormData, endDate: e.target.value})} required /></div>
//                                 </div>
//                                 <div className="form-group"><label>Reason</label><textarea rows="2" value={applyFormData.reason} onChange={e => setApplyFormData({...applyFormData, reason: e.target.value})} required /></div>
//                                 <button type="submit" className="btn-primary full" disabled={submitting}>{submitting ? <Loader className="spin" size={16} /> : "Submit"}</button>
//                             </form>
//                         </div>
//                     </div>
//                 )}

//                 {/* Rejection Modal */}
//                 {showRejectModal && (
//                     <div className="modal-overlay" onClick={() => setShowRejectModal(false)}>
//                         <div className="modal small-modal" onClick={e => e.stopPropagation()}>
//                             <div className="modal-head"><h3>Reject Request</h3></div>
//                             <div className="modal-body">
//                                 <p>Reason for rejection:</p>
//                                 <textarea rows="3" className="input-textarea" value={rejectData.reason} onChange={e => setRejectData({ ...rejectData, reason: e.target.value })} />
//                                 <div className="modal-actions">
//                                     <button onClick={() => setShowRejectModal(false)} className="btn-small cancel-text">Cancel</button>
//                                     <button onClick={confirmReject} className="btn-small reject-solid">Reject</button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )}

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../config';
import {
    Loader, Plus, Calendar as CalendarIcon, Settings, User, Users, FileText, Filter, RefreshCw,
    Edit2, Save, XCircle, CheckCircle, ChevronRight, Clock, Info, ChevronLeft
} from 'lucide-react';
import './LeavesManagment.css';

// --- INLINE STYLES FOR UTILS ---
const styles = {
    netDayBox: { backgroundColor: '#ecfdf5', padding: '10px', borderRadius: '8px', marginTop: '10px', border: '1px solid #10b981', display: 'flex', alignItems: 'center', gap: '8px' }
};

const LeavesManagment = () => {
    // --- CONFIGURATION ---
    const API_BASE = API_URL;
    const LEAVE_API = `${API_BASE}/leaves`;

    const [view, setView] = useState('list');
    const [userRole, setUserRole] = useState('OTHER');
    const [userName, setUserName] = useState('');
    const [loading, setLoading] = useState(true);

    // Calendar
    const [currentDate, setCurrentDate] = useState(new Date());

    // States
    const [submitting, setSubmitting] = useState(false);
    const [actionLoading, setActionLoading] = useState(null);
    const [stats, setStats] = useState({ allocated: 0, used: 0, pending: 0, remaining: 0 });
    const [userBalances, setUserBalances] = useState([]);
    const [leaveRequests, setLeaveRequests] = useState([]);
    const [leaveRequestsPagination, setLeaveRequestsPagination] = useState({ currentPage: 1, totalPages: 1, totalRecords: 0 });
    const [holidays, setHolidays] = useState([]);
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [policies, setPolicies] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [employeesPagination, setEmployeesPagination] = useState({ currentPage: 1, totalPages: 1, totalRecords: 0 });
    const [departments, setDepartments] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);

    // UI
    const [showApplyModal, setShowApplyModal] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectData, setRejectData] = useState({ id: null, reason: '' });
    const [statusFilter, setStatusFilter] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });

    // Forms
    const [applyFormData, setApplyFormData] = useState({ leaveMasterId: '', startDate: '', endDate: '', reason: '' });
    const [computedDays, setComputedDays] = useState(0);
    const [errors, setErrors] = useState({});

    // Policy Editing
    const [editingPolicyId, setEditingPolicyId] = useState(null);
    const [policyFormData, setPolicyFormData] = useState({
        daysAllowed: 0, carryForward: false, isPaid: true, gender: 'All',
        description: '', leaveMasterId: null,
        accrualEnabled: false, accrualRate: 0, accrualLimit: 0,
        accrualEarnedDaysRequired: 20
    });
    const [currentUserGender, setCurrentUserGender] = useState(null);

    const APPROVER_ROLES = ['SUPER_ADMIN', 'ADMIN', 'HR'];

    // --- HELPERS ---
    const getAuthHeader = () => {
        const token = localStorage.getItem('zTaskAuthToken');
        return { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } };
    };

    const getUserDetails = () => {
        try {
            const stored = localStorage.getItem('zTaskUserDetails');
            if (stored) {
                const parsed = JSON.parse(stored);
                return {
                    role: parsed.role?.name ? parsed.role.name.toUpperCase() : 'OTHER',
                    name: parsed.name || 'User',
                    id: parsed.id || null
                };
            }
        } catch (e) { console.error(e); }
        return { role: 'OTHER', name: 'User', id: null };
    };

    const showMessage = (text, type = 'success') => {
        setMessage({ text, type });
        setTimeout(() => setMessage({ text: '', type: '' }), 4000);
    };

    const toLocalYMD = (dateObj) => {
        if (!dateObj) return '';
        const offset = dateObj.getTimezoneOffset() * 60000;
        const local = new Date(dateObj.getTime() - offset);
        return local.toISOString().split('T')[0];
    };

    const normalizeDate = (dateStr) => {
        if (!dateStr) return '';
        if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) return dateStr;
        const parts = dateStr.split('-');
        if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`;
        return dateStr;
    };

    // --- LOAD DATA ---
    const fetchLeaveRequests = async (page = 1, limit = 10) => {
        const authHeader = getAuthHeader();
        try {
            const res = await axios.get(`${LEAVE_API}/requests?page=${page}&limit=${limit}`, authHeader);
            if (res.data.pagination) {
                setLeaveRequests(res.data.data);
                setLeaveRequestsPagination(res.data.pagination);
            } else {
                setLeaveRequests(res.data);
            }
        } catch (e) { console.error("Error fetching leaves:", e); }
    };

    const fetchEmployees = async (page = 1) => {
        const authHeader = getAuthHeader();
        try {
            const res = await axios.get(`${API_BASE}/hr/employees?page=${page}&limit=10`, authHeader);
            if (res.data.pagination) {
                setEmployees(res.data.data);
                setEmployeesPagination(res.data.pagination);
            } else {
                setEmployees(res.data);
            }
        } catch (e) { console.error("Error fetching employees:", e); }
    };

    const loadData = async () => {
        setLoading(true);
        const authHeader = getAuthHeader();

        try {
            const userInfo = getUserDetails();
            setUserRole(userInfo.role);
            setUserName(userInfo.name);

            // Fetch Leave Types 
            const leaveTypeRes = await axios.get(`${API_BASE}/get-column/common_master/leave_type`, authHeader);
            const formattedLeaveTypes = (leaveTypeRes.data || []).map(item => ({ id: parseInt(item.id), value: item.value || item.leave_type }));
            setLeaveTypes(formattedLeaveTypes);

            // Fetch Departments
            const deptRes = await axios.get(`${API_BASE}/get-column/departments/department_name`, authHeader);
            const formattedDepts = (deptRes.data || []).map(item => ({ id: parseInt(item.id), name: item.value }));
            setDepartments(formattedDepts);

            if (userInfo.id) {
                try {
                    const profileRes = await axios.get(`${API_BASE}/hr/employees/${userInfo.id}`, authHeader);
                    setCurrentUserGender(profileRes.data.gender || undefined);
                } catch (e) { console.warn("Gender fetch failed", e); }
            }

            const coreRequests = [
                axios.get(`${LEAVE_API}/summary`, authHeader),
                axios.get(`${API_BASE}/holidays`, authHeader)
            ];

            if (APPROVER_ROLES.includes(userInfo.role)) {
                coreRequests.push(axios.get(`${LEAVE_API}/policy`, authHeader));
            }

            const coreResponses = await Promise.all(coreRequests);

            const summaryData = coreResponses[0].data;
            setStats(summaryData.stats || { allocated: 0, used: 0, pending: 0, remaining: 0 });
            setUserBalances(summaryData.balances || []);
            setHolidays(coreResponses[1].data || []);

            if (APPROVER_ROLES.includes(userInfo.role)) {
                setPolicies(coreResponses[2].data || []);
            }

            // Fetch paginated lists
            await Promise.all([
                fetchLeaveRequests(1),
                APPROVER_ROLES.includes(userInfo.role) ? fetchEmployees(1) : Promise.resolve()
            ]);
        } catch (err) {
            console.error(err);
            showMessage("Failed to load data.", "error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadData(); }, []);

    useEffect(() => {
        if (view === 'calendar') {
            fetchLeaveRequests(1, 1000); // Load many for calendar
        } else if (view === 'list') {
            fetchLeaveRequests(1, 10); // Load paginated for list
        }
    }, [view]);

    const loadEmployeeDetails = async (emp) => {
        try {
            const auth = getAuthHeader();
            const [summaryRes, reqRes] = await Promise.all([
                axios.get(`${LEAVE_API}/summary?userId=${emp.id}`, auth),
                axios.get(`${LEAVE_API}/requests?userId=${emp.id}&limit=100`, auth)
            ]);

            const history = reqRes.data.pagination ? reqRes.data.data : reqRes.data;

            setSelectedEmployee({
                ...emp,
                leaveHistory: history,
                leaveStats: summaryRes.data.stats,
                leaveBalances: summaryRes.data.balances
            });
        } catch (err) {
            console.error("Detail load error:", err);
            showMessage("Failed to load details.", "error");
        }
    };

    const renderPagination = (pagination, onPageChange) => {
        if (!pagination || pagination.totalPages <= 1) return null;
        const { currentPage, totalPages } = pagination;
        return (
            <div className="pagination-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1rem', padding: '0 1rem' }}>
                <span style={{ fontSize: '0.85rem', color: '#64748b' }}>Page {currentPage} of {totalPages}</span>
                <div style={{ display: 'flex', gap: '5px' }}>
                    <button
                        disabled={currentPage === 1}
                        onClick={() => onPageChange(currentPage - 1)}
                        className="btn-refresh"
                    >
                        <ChevronLeft size={16} />
                    </button>
                    {[...Array(totalPages)].map((_, i) => {
                        const p = i + 1;
                        if (totalPages > 5 && Math.abs(p - currentPage) > 1 && p !== 1 && p !== totalPages) {
                            if (Math.abs(p - currentPage) === 2) return <span key={p}>...</span>;
                            return null;
                        }
                        return (
                            <button
                                key={p}
                                onClick={() => onPageChange(p)}
                                className={`btn-refresh ${currentPage === p ? 'active' : ''}`}
                                style={currentPage === p ? { backgroundColor: '#2563eb', color: 'white' } : {}}
                            >
                                {p}
                            </button>
                        );
                    })}
                    <button
                        disabled={currentPage === totalPages}
                        onClick={() => onPageChange(currentPage + 1)}
                        className="btn-refresh"
                    >
                        <ChevronRight size={16} />
                    </button>
                </div>
            </div>
        );
    };

    // --- DATE CALCULATIONS ---
    const calculateLeaveDays = (startStr, endStr) => {
        if (!startStr || !endStr) return 0;
        const start = new Date(startStr);
        const end = new Date(endStr);
        if (end < start) return 0;

        let count = 0;
        let current = new Date(start);
        const holidaySet = new Set(holidays.map(h => normalizeDate(h.date)));

        while (current <= end) {
            const dayOfWeek = current.getDay();
            const dateString = toLocalYMD(current);
            const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
            const isHoliday = holidaySet.has(dateString);

            if (!isWeekend && !isHoliday) count++;
            current.setDate(current.setDate() + 1);
        }
        return count;
    };

    useEffect(() => {
        setComputedDays(calculateLeaveDays(applyFormData.startDate, applyFormData.endDate));
    }, [applyFormData.startDate, applyFormData.endDate, holidays]);

    // --- CALENDAR RENDERER ---
    const getDaysInMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    const getFirstDayOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1).getDay();
    const prevMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
    const nextMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));

    const renderCalendar = () => {
        const daysInMonth = getDaysInMonth(currentDate);
        const firstDay = getFirstDayOfMonth(currentDate);
        const days = [];

        // Previous month empty cells
        for (let i = 0; i < firstDay; i++) {
            days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
        }

        // Current month days
        for (let day = 1; day <= daysInMonth; day++) {
            const dateObj = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
            const dateStr = toLocalYMD(dateObj);
            const dayOfWeek = dateObj.getDay();

            const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
            const holiday = holidays.find(h => normalizeDate(h.date) === dateStr);
            const dayLeaves = leaveRequests.filter(req => req.status !== 'rejected' && dateStr >= req.start_date && dateStr <= req.end_date);

            let dayClasses = "calendar-day";
            if (isWeekend) dayClasses += " weekend";
            if (holiday) dayClasses += " holiday";

            days.push(
                <div key={day} className={dayClasses}>
                    <div className="day-header">
                        <span className="day-number">{day}</span>
                        {isWeekend && <span className="off-badge">OFF</span>}
                    </div>

                    {holiday && (
                        <div className="holiday-info" title={holiday.name}>
                            <span className="holiday-dot"></span>
                            <span className="holiday-name">{holiday.name}</span>
                        </div>
                    )}

                    <div className="day-events-container">
                        {dayLeaves.map((l, idx) => (
                            <div key={`${day}-${idx}`} className={`calendar-event-pill status-${l.status}`} title={`${l.employee_name} - ${l.type}`}>
                                <span className="event-dot"></span>
                                <span className="event-name">{l.employee_name?.split(' ')[0]}</span>
                                <div className="calendar-tooltip">
                                    <div className="tooltip-header">
                                        <strong>{l.employee_name}</strong>
                                        <span className={`status-badge ${l.status}`}>{l.status}</span>
                                    </div>
                                    <div className="tooltip-body">
                                        <div className="tooltip-row"><span>Type:</span> <span>{l.type}</span></div>
                                        <div className="tooltip-row"><span>Dates:</span> <span>{l.start_date} - {l.end_date}</span></div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            );
        }
        return days;
    };

    // --- ACTIONS ---
    const handleApplySubmit = async (e) => {
        e.preventDefault();
        const err = {};
        if (!applyFormData.leaveMasterId) err.policy = "Select type";
        if (computedDays === 0) err.endDate = "Net days is 0 (Holiday/Weekend)";

        const balance = userBalances.find(b => b.leave_master_id === parseInt(applyFormData.leaveMasterId));
        if (balance && computedDays > balance.remaining) err.policy = `Insufficient Balance (${balance.remaining} avail)`;

        if (Object.keys(err).length > 0) { setErrors(err); return; }

        setSubmitting(true);
        try {
            await axios.post(`${LEAVE_API}/request`, {
                ...applyFormData,
                totalDays: computedDays,
                userId: getUserDetails().id,
                leaveMasterId: parseInt(applyFormData.leaveMasterId)
            }, getAuthHeader());
            showMessage("Request submitted!");
            setShowApplyModal(false);
            setApplyFormData({ leaveMasterId: '', startDate: '', endDate: '', reason: '' });
            loadData();
        } catch (e) { showMessage("Failed to submit.", "error"); }
        finally { setSubmitting(false); }
    };

    const savePolicy = async () => {
        try {
            const data = {
                ...policyFormData,
                leaveMasterId: Number(policyFormData.leaveMasterId),
                daysAllowed: Number(policyFormData.daysAllowed),
                isPaid: Boolean(policyFormData.isPaid),
                gender: policyFormData.gender,
                accrualEnabled: Boolean(policyFormData.accrualEnabled),
                accrualRate: Number(policyFormData.accrualRate),
                accrualLimit: Number(policyFormData.accrualLimit),
                accrualEarnedDaysRequired: Number(policyFormData.accrualEarnedDaysRequired)
            };
            const existing = policies.find(p => Number(p.leave_master_id) === Number(data.leaveMasterId));
            if (existing?.id) await axios.put(`${LEAVE_API}/policy/${existing.id}`, data, getAuthHeader());
            else await axios.post(`${LEAVE_API}/policy`, data, getAuthHeader());
            loadData();
            setEditingPolicyId(null);
            showMessage("Policy saved!");
        } catch (e) { showMessage("Failed to save policy.", "error"); }
    };

    const handleApprove = async (id) => {
        try {
            await axios.put(`${LEAVE_API}/request/${id}/status`, { status: 'approved' }, getAuthHeader());
            loadData(); showMessage("Approved!");
        } catch (e) { showMessage("Failed.", "error"); }
    };

    const confirmReject = async () => {
        try {
            await axios.put(`${LEAVE_API}/request/${rejectData.id}/status`, { status: 'rejected', rejectionReason: rejectData.reason }, getAuthHeader());
            loadData(); showMessage("Rejected."); setShowRejectModal(false);
        } catch (e) { showMessage("Failed.", "error"); }
    };

    const mergedPolicies = leaveTypes.map(type => {
        const pol = policies.find(p => Number(p.leave_master_id) === Number(type.id)) || {};
        return {
            ...type,
            ...pol,
            id: pol.id || null,
            days_allowed: pol.days_allowed ?? 0,
            carry_forward: pol.carry_forward ?? false,
            is_paid: pol.is_paid ?? true,
            gender_eligibility: pol.gender_eligibility || 'All',
            accrual_earned_days_required: pol.accrual_earned_days_required ?? 20,
            accrual_enabled: pol.accrual_enabled ?? false,
            accrual_rate_per_month: pol.accrual_rate_per_month ?? 0,
            accrual_max_limit: pol.accrual_max_limit ?? 0,
            description: pol.description || '',
            leaveMasterId: Number(type.id),
            policy_name: pol.policy_name || type.value
        };
    });

    if (loading) return <div className="app-loader">Loading...</div>;

    return (
        <div className="leaves-management-scope">
            {message.text && <div className={`toast ${message.type}`}>{message.text}</div>}

            <div className="page-container">
                <header className="page-header">
                    <div className="header-left"><h1>Leave Portal</h1><div className="user-info"><User size={12} />{userName} ({userRole})</div></div>
                    <div className="header-right">
                        <div className="tabs">
                            <button className={view === 'list' ? 'active' : ''} onClick={() => setView('list')}><FileText size={14} /> Requests</button>
                            <button className={view === 'calendar' ? 'active' : ''} onClick={() => setView('calendar')}><CalendarIcon size={14} /> Calendar</button>
                            {(userRole === 'ADMIN' || userRole === 'SUPER_ADMIN' || userRole === 'HR') && <button className={view === 'policies' ? 'active' : ''} onClick={() => setView('policies')}><Settings size={14} /> Policies</button>}
                            {APPROVER_ROLES.includes(userRole) && <button className={view === 'employees' ? 'active' : ''} onClick={() => setView('employees')}><Users size={14} /> Employees</button>}
                        </div>
                        <button className="btn-apply" onClick={() => setShowApplyModal(true)}><Plus size={14} /> Apply</button>
                        <button className="btn-refresh" onClick={loadData}><RefreshCw size={14} /></button>
                    </div>
                </header>

                {view === 'list' && !selectedEmployee && (
                    <>
                        <div className="stats-grid">
                            <div className="stat-card"><div className="icon blue"><FileText size={20} /></div><div><p>Allocated</p><h3>{stats.allocated}</h3></div></div>
                            <div className="stat-card"><div className="icon green"><User size={20} /></div><div><p>Remaining</p><h3>{stats.remaining}</h3></div></div>
                        </div>
                        <div className="card" style={{ marginTop: '1rem' }}>
                            <div className="card-header"><h3>Leave Requests</h3></div>
                            <table className="table">
                                <thead><tr><th>Employee</th><th>Type</th><th>Dates</th><th>Days</th><th>Status</th>{APPROVER_ROLES.includes(userRole) && <th>Actions</th>}</tr></thead>
                                <tbody>{leaveRequests && leaveRequests.length > 0 ? leaveRequests.map(r => (
                                    <tr key={r.id}>
                                        <td><div className="employee"><div className="avatar">{r.employee_name?.[0]}</div><span style={{ fontWeight: 600 }}>{r.employee_name}</span></div></td>
                                        <td><span className="type-badge">{r.type}</span></td>
                                        <td>{r.start_date} → {r.end_date}</td><td>{r.days}</td>
                                        <td>
                                            <div className="status-cell-container">
                                                <span className={`status ${r.status}`}>
                                                    {r.status}
                                                </span>
                                                {r.status === 'rejected' && (
                                                    <div className="status-tooltip">
                                                        <div className="tooltip-header">
                                                            <strong>Rejection Reason</strong>
                                                        </div>
                                                        <div className="tooltip-body" style={{ marginTop: '5px' }}>
                                                            {r.rejection_reason || r.rejectionReason || 'No reason provided'}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        {APPROVER_ROLES.includes(userRole) && r.status === 'pending' && (
                                            <td><button onClick={() => handleApprove(r.id)} className="btn-small save"><CheckCircle size={16} /></button><button onClick={() => { setRejectData({ id: r.id, reason: '' }); setShowRejectModal(true) }} className="btn-small cancel"><XCircle size={16} /></button></td>
                                        )}
                                    </tr>
                                )) : <tr><td colSpan={APPROVER_ROLES.includes(userRole) ? 6 : 5} style={{ textAlign: 'center', padding: '2rem' }}>No requests found</td></tr>}</tbody>
                            </table>
                            {renderPagination(leaveRequestsPagination, fetchLeaveRequests)}
                        </div>
                    </>
                )}

                {view === 'calendar' && (
                    <div className="card">
                        <div className="calendar-header">
                            <div style={{ display: 'flex', gap: 10 }}><CalendarIcon size={18} color="#2563eb" /><h3>{currentDate.toLocaleDateString('default', { month: 'long', year: 'numeric' })}</h3></div>
                            <div style={{ display: 'flex', gap: 5 }}><button onClick={prevMonth} className="btn-refresh"><ChevronLeft size={16} /></button><button onClick={nextMonth} className="btn-refresh"><ChevronRight size={16} /></button></div>
                        </div>
                        <div className="calendar-legend">
                            <span className="legend-item"><span className="dot holiday"></span> Holiday</span>
                            <span className="legend-item"><span className="dot weekend"></span> Weekend</span>
                            <span className="legend-item"><span className="dot approved"></span> Approved</span>
                            <span className="legend-item"><span className="dot pending"></span> Pending</span>
                        </div>
                        <div className="calendar-grid">
                            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => <div key={d} className="calendar-head">{d}</div>)}
                            {renderCalendar()}
                        </div>
                    </div>
                )}

                {view === 'employees' && APPROVER_ROLES.includes(userRole) && !selectedEmployee && (
                    <div className="card"><div className="card-header"><h3>Employees</h3></div>
                        <table className="table"><thead><tr><th>Name</th><th>Email</th><th>Dept</th><th>Status</th><th></th></tr></thead><tbody>
                            {employees.map(e => (<tr key={e.id} onClick={() => loadEmployeeDetails(e)} style={{ cursor: 'pointer' }}><td>{e.first_name} {e.last_name}</td><td>{e.email}</td><td>{departments.find(d => d.id === e.department_id)?.name || '-'}</td><td><span className="status approved">{e.status_name}</span></td><td><ChevronRight size={16} /></td></tr>))}
                        </tbody></table>
                        {renderPagination(employeesPagination, fetchEmployees)}
                    </div>
                )}

                {selectedEmployee && (
                    <div className="card">
                        <div className="card-header"><button onClick={() => setSelectedEmployee(null)} className="btn-refresh">← Back</button><h3>{selectedEmployee.first_name}</h3></div>
                        <div style={{ padding: '1rem' }}><table className="table"><thead><tr><th>Type</th><th>Dates</th><th>Days</th><th>Status</th></tr></thead><tbody>
                            {selectedEmployee.leaveHistory?.map(h => <tr key={h.id}><td>{h.type}</td><td>{h.start_date} → {h.end_date}</td><td>{h.days}</td><td>{h.status}</td></tr>)}
                        </tbody></table></div>
                    </div>
                )}

                {view === 'policies' && (userRole === 'ADMIN' || userRole === 'SUPER_ADMIN') && (
                    <div className="card"><div className="card-header"><h3>Policies</h3></div>
                        <table className="table"><thead><tr><th>Name</th><th>Allotted</th><th>Earned?</th><th>Rate/mo</th><th>Days Req</th><th>Max</th><th>C/F</th><th>Paid?</th><th>Eligible</th><th>Actions</th></tr></thead><tbody>
                            {mergedPolicies.map(p => (
                                <tr key={p.leaveMasterId}>
                                    <td>{p.policy_name}</td>
                                    <td>{editingPolicyId === p.leaveMasterId ? <input type="number" style={{ width: 50 }} value={policyFormData.daysAllowed} onChange={e => setPolicyFormData({ ...policyFormData, daysAllowed: e.target.value })} /> : p.days_allowed}</td>
                                    <td>{editingPolicyId === p.leaveMasterId ? <input type="checkbox" checked={policyFormData.accrualEnabled} onChange={e => setPolicyFormData({ ...policyFormData, accrualEnabled: e.target.checked })} /> : (p.accrual_enabled ? 'Yes' : 'No')}</td>
                                    <td>{editingPolicyId === p.leaveMasterId ? (policyFormData.accrualEnabled ? <input type="number" step="0.1" style={{ width: 50 }} value={policyFormData.accrualRate} onChange={e => setPolicyFormData({ ...policyFormData, accrualRate: e.target.value })} /> : '-') : (p.accrual_enabled ? p.accrual_rate_per_month : '-')}</td>
                                    <td>{editingPolicyId === p.leaveMasterId ? (policyFormData.accrualEnabled ? <input type="number" step="1" style={{ width: 50 }} value={policyFormData.accrualEarnedDaysRequired} onChange={e => setPolicyFormData({ ...policyFormData, accrualEarnedDaysRequired: e.target.value })} /> : '-') : (p.accrual_enabled ? p.accrual_earned_days_required : '-')}</td>
                                    <td>{editingPolicyId === p.leaveMasterId ? (policyFormData.accrualEnabled ? <input type="number" style={{ width: 50 }} value={policyFormData.accrualLimit} onChange={e => setPolicyFormData({ ...policyFormData, accrualLimit: e.target.value })} /> : '-') : (p.accrual_enabled ? p.accrual_max_limit : '-')}</td>
                                    <td>{editingPolicyId === p.leaveMasterId ? <input type="checkbox" checked={policyFormData.carryForward} onChange={e => setPolicyFormData({ ...policyFormData, carryForward: e.target.checked })} /> : (p.carry_forward ? 'Yes' : 'No')}</td>
                                    <td>{editingPolicyId === p.leaveMasterId ? <input type="checkbox" checked={policyFormData.isPaid} onChange={e => setPolicyFormData({ ...policyFormData, isPaid: e.target.checked })} /> : (p.is_paid ? <span style={{ color: 'green', fontWeight: 'bold' }}>Yes</span> : <span style={{ color: 'red' }}>No</span>)}</td>
                                    <td>{editingPolicyId === p.leaveMasterId ? (
                                        <select value={policyFormData.gender} onChange={e => setPolicyFormData({ ...policyFormData, gender: e.target.value })} style={{ padding: '2px' }}>
                                            <option value="All">All</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                        </select>
                                    ) : (p.gender_eligibility)}</td>
                                    <td>{editingPolicyId === p.leaveMasterId ? <><button onClick={savePolicy} className="btn-small save"><Save size={14} /></button><button onClick={() => setEditingPolicyId(null)} className="btn-small cancel"><XCircle size={14} /></button></> : <button onClick={() => { setEditingPolicyId(p.leaveMasterId); setPolicyFormData({ daysAllowed: p.days_allowed, carryForward: p.carry_forward, isPaid: p.is_paid, gender: p.gender_eligibility || 'All', description: p.description, leaveMasterId: p.leaveMasterId, accrualEnabled: p.accrual_enabled, accrualRate: p.accrual_rate_per_month, accrualLimit: p.accrual_max_limit, accrualEarnedDaysRequired: p.accrual_earned_days_required }) }} className="btn-small edit"><Edit2 size={14} /></button>}</td>
                                </tr>
                            ))}
                        </tbody></table></div>
                )}

                {showApplyModal && (
                    <div className="modal-overlay" onClick={() => setShowApplyModal(false)}>
                        <div className="modal" onClick={e => e.stopPropagation()}>
                            <div className="modal-head"><h3>Apply Leave</h3><button onClick={() => setShowApplyModal(false)}><XCircle size={18} /></button></div>
                            <form onSubmit={handleApplySubmit}>
                                <div className="radio-group-container">
                                    {mergedPolicies.map(t => {
                                        const bal = userBalances.find(b => b.leave_master_id === t.leaveMasterId)?.remaining || 0;
                                        // Gender Check: If user gender is loaded, compare. Default compatible if gender unknown (to avoid blocking on load error).
                                        // Actually, if 'Female' only and userGender is 'Male', block.
                                        const isGenderCompatible = t.gender_eligibility === 'All' || !currentUserGender || t.gender_eligibility.toLowerCase() === currentUserGender.toLowerCase();

                                        return <div key={t.leaveMasterId}
                                            className={`radio-option ${parseInt(applyFormData.leaveMasterId) === t.leaveMasterId ? 'selected' : ''} ${(bal <= 0 || !isGenderCompatible) ? 'disabled' : ''}`}
                                            onClick={() => { if (bal > 0 && isGenderCompatible) setApplyFormData({ ...applyFormData, leaveMasterId: t.leaveMasterId }) }}>
                                            <strong>{t.policy_name} {t.is_paid ? '' : <span style={{ color: '#ef4444', fontSize: '0.8em' }}>(Unpaid)</span>}</strong>
                                            <br />
                                            <small>{bal} Left</small>
                                            {!isGenderCompatible && <div style={{ fontSize: '0.75em', color: 'red', marginTop: '2px' }}>Only for {t.gender_eligibility}s</div>}
                                        </div>
                                    })}
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                                    <div><label>Start</label><input type="date" value={applyFormData.startDate} onChange={e => setApplyFormData({ ...applyFormData, startDate: e.target.value })} required /></div>
                                    <div><label>End</label><input type="date" value={applyFormData.endDate} onChange={e => setApplyFormData({ ...applyFormData, endDate: e.target.value })} required /></div>
                                </div>
                                <div style={styles.netDayBox}><Info size={14} style={{ verticalAlign: 'middle' }} /> <strong>Net Days: {computedDays}</strong> <span style={{ fontSize: 10 }}>(Excl. Weekends/Holidays)</span></div>
                                {errors.endDate && <div className="error">{errors.endDate}</div>}
                                <div><label>Reason</label><textarea value={applyFormData.reason} onChange={e => setApplyFormData({ ...applyFormData, reason: e.target.value })} required /></div>
                                <button type="submit" className="btn-primary full" disabled={submitting}>{submitting ? <Loader className="spin" size={16} /> : 'Submit'}</button>
                            </form>
                        </div>
                    </div>
                )}

                {showRejectModal && (
                    <div className="modal-overlay">
                        <div className="modal" style={{ maxWidth: 400 }}>
                            <div className="modal-head"><h3>Reject</h3></div>
                            <div style={{ padding: '1rem' }}><textarea value={rejectData.reason} onChange={e => setRejectData({ ...rejectData, reason: e.target.value })} placeholder="Reason..." />
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 10 }}><button onClick={() => setShowRejectModal(false)} className="btn-refresh">Cancel</button><button onClick={confirmReject} className="btn-apply" style={{ background: 'var(--danger)' }}>Reject</button></div></div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LeavesManagment;